/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
/* eslint-disable */
import {
  Button,
  Modal,
  Collapse,
  Row,
  Col,
  Form,
  Input,
  Select,
  message,
  Spin,
  Checkbox,
  theme,
  AutoComplete,
  Tag,
  Typography,
  Tooltip,
  Divider
} from 'antd';
import { getMuestrasByidMonitoreo } from 'actions/monitoreos.actions';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { showAlert } from 'actions/alert.actions';
import useScreenSize from 'utils/useScreenSize';
import { PlusOutlined, DeleteOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { SimpleNumericInput, AddButton } from 'components';
import { PERSONALIZADO, GENERICO, CONJUNTO, DIRECTO } from 'constants/tipoBeneficio';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookie from 'universal-cookie';
import {
  PROCESOS_ESPECIFICOS,
  ATRIBUTOS,
  ESTADOS,
  BENEFICIADOS,
  TIPO_BENEFICIO,
  PROCESOS_ELECTORALES
} from 'constants/nombresCatalogos';
import {
  selectCatalogByName,
  selectTipoHallazgoByIdMonitoreo,
  selectCatalogs
} from 'selectors/catalogos.selectors';
// import base85 from 'base85';
import { MONITOREOS_ESPECTACULARES } from 'constants/tipoMonitoreos';
import { groupObjectsByProperty } from 'utils/groupObjectsByProperty';
import { removeDuplicatesByProperty } from 'utils/removeDuplicatedByProperty';
import { scrollToErrorField } from 'utils/form/scollToErrorFiled';
import { generateId } from 'utils/idGenerator';
import { newFormatBeneficiados } from 'adapters/formatoMonitoreoEspectaculares';
import { updateMonitoreo, getCatalogIdINEByEdo } from 'actions/actas.actions';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { ReactComponent as IconReloj } from 'assets/images/monitoreos/SIMAC_Icono_reloj.svg';
import { useSetBeneficiados } from './hooks/useSetBeneficiados';
import * as actasService from '../../../services/espectacularesActas';
import { imgDefaultVideo } from '../../Monitoreos/MediosImpresos/components/modalVideo';
import DatosGenerales from './components/DatosGenerales';
import TipoHallazgo from './components/TipoHallazgo';
import Ubicacion from './components/Ubicacion';
import Muestras from './components/Muestras';
import Upload from '../../../components/Upload/Upload';
import './ModalHallazgo.scss';

import { generarPDFMonitoreos } from 'services/monitoreos.service';

const { Text } = Typography;

const getBeneficiadosPorAsociacionId = (listaAsociaciones, beneficiadoId) => {
  const asociacion = listaAsociaciones?.find((b) => b.idTipoAsociacion === beneficiadoId);
  return asociacion?.beneficiarios || [];
};

const getTiposAsociacionPorProcesoEspecifico = (listaBeneficiadosCompleta, procesoEspecificoId) => {
  // Validaciones "INTERCAMPAÑA"
  // Solo para procesos específicos diferentes a "INTERCAMPAÑA" se filtra por el procesoEspecificoId
  // De lo contrario al ser 4 no realiza dicho filtro.
  let listaBeneficiados = [];
  if (procesoEspecificoId === 4) {
    listaBeneficiados = listaBeneficiadosCompleta;
  } else {
    listaBeneficiados = listaBeneficiadosCompleta.filter(
      (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
    );
  }

  const asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');

  // RETORNO "INTERCAMPAÑA"
  if (procesoEspecificoId === 4) {
    const resultado = Object.keys(asociaciones).map((tipoAsociacion) => {
      return {
        tipoAsociacion,
        idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
        beneficiarios: asociaciones[tipoAsociacion]
      };
    });

    const asociacionesAgrupadas = resultado.reduce((acc, item) => {
      const { idTipoAsociacion, tipoAsociacion, beneficiarios } = item;

      // Si el grupo no existe, se inicializa
      if (!acc[idTipoAsociacion]) {
        acc[idTipoAsociacion] = {
          idTipoAsociacion,
          tipoAsociacion,
          beneficiarios: []
        };
      } else {
        // Concatenar tipoAsociacion con una diagonal si ya existe
        acc[idTipoAsociacion].tipoAsociacion += ` / ${tipoAsociacion}`;
      }

      // Agregar los beneficiarios a la lista existente
      acc[idTipoAsociacion].beneficiarios.push(...beneficiarios);

      return acc;
    }, {});

    // Convertir el objeto en un array si se requiere ese formato
    const resultadoFinal = Object.values(asociacionesAgrupadas);

    // console.log("Datos agrupados:", resultadoFinal);
    return resultadoFinal;
  } else {
    const resultado = Object.keys(asociaciones).map((tipoAsociacion) => {
      return {
        tipoAsociacion:
          tipoAsociacion === 'PRECANDIDATO'
            ? `${tipoAsociacion} / PARTIDO POLITICO`
            : tipoAsociacion,
        idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
        beneficiarios: asociaciones[tipoAsociacion]
      };
    });

    return resultado;
  }
};

const getCargosPorProcesoEspecifico = (listaBeneficiadosCompleta, procesoEspecificoId) => {
  const listaBeneficiados = listaBeneficiadosCompleta.filter(
    (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  );
  const cargos = groupObjectsByProperty(listaBeneficiados, 'cargo');
  return Object.keys(cargos).map((cargo) => {
    return {
      cargo,
      idCargo: generateId()
    };
  });
};

const format = 'HH:mm';
const { TextArea } = Input;
const acta = {
  idActa: '',
  fechaApertura: '',
  fechaCierre: '',
  fiscalizacion: [],
  juntaLocalDistrital: [],
  sujetosObligados: []
};
let ubicacion = {
  calle: '',
  codigoPostal: '',
  colonia: '',
  entreCalle1: '',
  entreCalle2: '',
  numero: '',
  referencias: '',
  idMunicipio: '',
  idEntidad: '',
  idUbicacion: '',
  latitud: '',
  longitud: ''
};
let fiscalizacion = {
  extra: '',
  puesto: '',
  autorizadoPor: '',
  numConstancia: ''
};
let fisca = [];
const fiscaP = {
  muestras: []
};
const juntaLocalDistrital = {
  extra: '',
  puesto: '',
  numeroJunta: ''
};
const SujetosObligados = {
  idTipoAsociacion: '',
  puesto: '',
  numeroJunta: ''
};
const monitoreo = {
  idProcesoElectoral: '',
  acta: [],
  usoVoz: '',
  otrosHechos: '',
  recorrido: '',
  idMonitoreo: ''
};
let beneficiados = {
  idTipoAsociacion: '',
  idSujetoObligado: '',
  cargo: '',
  idContabilidad: '',
  nombreBeneficiado: '',
  tipoBeneficio: '',
  idBeneficiado: ''
};
const hallazgo = {
  pkHallazgo: 100,
  beneficiados: [],
  muestras: []
};
const listaUser = [];
let userTable = {
  key: '',
  tipoAsociacion: '',
  idtipoAsociacion: '',
  sujetoObligado: '',
  idsujetoObligado: '',
  cargo: '',
  idcargo: '',
  beneficiado: '',
  idContabilidad: '',
  idBeneficiado: ''
};
const municipios = [];
let municipio = {
  id: '',
  nombre: ''
};

const sujetosObligados = [];
let sujetosObligado = {
  id: '',
  nombre: ''
};
const cargos = [];
let cargo = {
  id: '',
  nombre: ''
};
let asociaciones = [];
let asociacion = {
  id: '',
  nombre: ''
};
const Distritos = [];
let distrito = {
  id: '',
  nombre: ''
};
let DistritosF = [];
let distritoF = {
  id: '',
  nombre: ''
};
const catHallazgos = [];
let catHallazgo = {
  id: '',
  nombre: ''
};
const medidas = [];
let medida = {
  id: '',
  nombre: ''
};
const catbeneficiados = [];
let beneficiado = {
  id: '',
  nombre: ''
};
const catProcesosElectorales = [];
let catProcesosElectoral = {
  id: '',
  nombre: ''
};
let catProcesosElectoralesEspe = [];
let catProcesosElectoralESpe = {
  id: '',
  nombre: ''
};
const catIdContabilidades = [];
let catIdContabilidad = {
  id: '',
  nombre: ''
};
let benefico = '';
let asicioacionNUeva = 0;
let sujetoObligadoNUeva = 0;
let cargoNUeva = 0;
let nombreBeneficiario = 0;
let idContabilidad = 0;
let imagenesEliminadas = [];
let muestrasImagen = {
  tipoMuestra: '',
  imagen: ''
};
let atr;

// eslint-disable-next-line no-unused-vars
function ModalActa({
  open,
  callback,
  dataActa,
  call,
  renderBeneficiados,
  setIsVisibleSuccessModal
}) {
  const dispatch = useDispatch();
  let UploadFileS = [];
  // -------------------------BENEFICIADOS---------------------------
  const { token } = theme.useToken();
  const beneficiadosList = useSelector(selectCatalogByName(BENEFICIADOS));
  const [listaBeneficiados, setListaBeneficiados] = useState([]);
  const tipoBeneficios = useSelector(selectCatalogByName(TIPO_BENEFICIO));
  const [tipoBeneficioSelecionado, setTipoBeneficioSeleccionado] = useState();
  const [renderBeneficiadosEdit, setRenderBeneficiadosEdit] = useState();
  const [listTipoAsociacion, setListTipoAsociacion] = useState([]);
  const [listSujetosObligados, setListSujetosObligados] = useState([]);
  const [listCargos, setListCargos] = useState([]);
  const [tags, setTags] = useState([]);
  const [infoBeneficiados, setInfoBeneficiados] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputSujetoObligadoVisible, setInputSujetoObligadoVisible] = useState(false);
  const [inputSujetoObligadoGenConjVisible, setInputSujetoObligadoGenConjVisible] = useState(false);
  const [inputCargoVisible, setInputCargoVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const inputRefSO = useRef(null);
  const inputRefSOGC = useRef(null);
  // -------------------------BENEFICIADOS---------------------------
  const [messageApi, contextHolder] = message.useMessage();
  const [sujetosEliminados, setsujetosEliminados] = useState([]);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [renderDistrito, setrenderDistrito] = useState(0);
  const [fileList, setFileList] = useState([]);
  const [muestrasList, setMuestrasList] = useState([]);
  const [list, setList] = useState([]);
  const [catDistritosF, setcatDistritosF] = useState([]);
  const [catDistritosL, setcatDistritosL] = useState([]);
  const [searchValue, setSearchValue] = useState(0);
  const [hallazgoCancelado, sethallazgoCancelado] = useState(false);
  const [count, setSCount] = useState(0);
  // const [ambito, setAmbito] = useState(true);
  const [atributos, setatributos] = useState('');
  const [idIneImput, setidIneImput] = useState(false);
  const [corte, setConter] = useState(0);
  const [dataMunicipios, setMunicipios] = useState([]);
  const newList = useSelector((state) => state.hallazgo.list);
  const [beneficioActa, setbeneficio] = useState(0);
  const [atrCantidad, setatrCantidad] = useState(false);
  const [atrduracionHr, setatrduracionHr] = useState(false);
  const [atrduracionMin, setatrduracionMin] = useState(false);
  const [atrduracionSeg, setatrduracionSeg] = useState(false);
  const [atrcampaniaAnterior, setatrcampaniaAnterior] = useState(false);
  const [atrcampaniaAnteriorUse, setatrcampaniaAnteriorUse] = useState(0);
  const [atrCampaniaAnteriorCheck, setAtrCampaniaAnteriorCheck] = useState(false);
  const [atrAncho, setatrAncho] = useState(false);
  const [atrAlto, setatrAlto] = useState(false);
  const [atrLema, setatrLema] = useState(false);
  const [atrPlacas, setatrPlacas] = useState(false);
  const [atrMedida, setatrMedida] = useState(false);
  const [atrTipoMedida, setatrTipoMedida] = useState(false);
  const [atrinfoAdicional, setatrinfoAdicional] = useState(false);
  const [renderString, setrenderString] = useState('');
  const procesosEspe = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const setBeneficiados = useSetBeneficiados();

  // -------------------------CATALOGO ENTIDADES---------------------------
  const [catIdIne, setCatIdIne] = useState([]);

  const [activeKey, setActiveKey] = useState(['']);

  const tipoHallazgos = useSelector(selectTipoHallazgoByIdMonitoreo(MONITOREOS_ESPECTACULARES));
  const entidades = useSelector(selectCatalogByName(ESTADOS));

  const catalogosStore = {};
  catalogosStore.procesosEspe = procesosEspe;

  const catalogos = useSelector(selectCatalogs);

  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosElectorales = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));

  let c = 0;
  let codeUploadFile = {};
  const handleCancel = () => {
    setatrcampaniaAnteriorUse(0);
    imagenesEliminadas = [];
    setrenderString('');
    setidIneImput(false);
    // call(); // MNI - Se oculta llamado ya que este hacía una consulta al API cuando se cancelaba una edición al hallazgo.
    if (c > 0) {
      setTimeout(() => {
        callback(false);
        setbeneficio(0);
        setSCount(0);
        setSearchValue(0);
        setConter(0);
        setList([]);
        setFileList([]);
        setMuestrasList([]);
        UploadFileS = [];
        codeUploadFile = {};
        muestrasImagen = {};
        imagenesEliminadas = [];
      }, 5000);
    } else {
      callback(false);
      setbeneficio(0);
      setSCount(0);
      setSearchValue(0);
      setConter(0);
      setList([]);
      setFileList([]);
      setMuestrasList([]);
      UploadFileS = [];
      codeUploadFile = {};
      muestrasImagen = {};
      imagenesEliminadas = [];
    }
  };

  const [form] = Form.useForm();
  const { Panel } = Collapse;
  let folio = '';

  const optionsEstatus = [
    { id: 4, nombre: 'Validado' },
    { id: 2, nombre: 'No validado' },
    { id: 3, nombre: 'Cancelado' }
  ];

  if (open) {
    folio = dataActa.Folio;
    if (count === 0) {
      setSCount(1);
    }
  }
  const monitoreos = [];
  let catmonitoreo = {
    id: '',
    nombre: ''
  };

  const initAPP = async () => {
    // const fields = await form?.validateFields();
    form.setFieldsValue({
      placas: dataActa.placas
    });
    if (dataActa.campaniaAnterior === undefined && hallazgo.campaniaAnterior === undefined) {
      setAtrCampaniaAnteriorCheck(false);
    } else if (dataActa.campaniaAnterior !== undefined) {
      if (dataActa.campaniaAnterior === 0) {
        setAtrCampaniaAnteriorCheck(false);
      }
      if (dataActa.campaniaAnterior === 1) {
        setAtrCampaniaAnteriorCheck(true);
      }
    }
    if (open) {
      let Estado = '';
      setLoading(false);
      try {
        if (searchValue === 0) {
          // if (dataActa.ambitoMonitoreo === 3) {
          // setAmbito(false);
          // }
          if (dataActa.estatus === 'Cancelado') {
            sethallazgoCancelado(true);
          } else {
            sethallazgoCancelado(false);
          }
          if (dataActa.idIne !== undefined && dataActa.idIne.length > 4) {
            // buscarIdIneEstado();
            // eslint-disable-next-line no-use-before-define
            //  renderIdIne(dataActa.idIne);
            form.setFieldsValue({
              idTipoMedida: dataActa.idTipoMedida
            });
          }
          if (dataActa.campaniaAnterior !== undefined) {
            setatrcampaniaAnteriorUse(dataActa.campaniaAnterior);
          }
          DistritosF = [];
          setcatDistritosF([]);
          setcatDistritosL([]);
          setsujetosEliminados([]);
          // eslint-disable-next-line array-callback-return
          dataActa.catBeneficiado.map((v) => {
            cargo = {};
            cargo.id = v.idRow;
            cargo.nombre = v.cargo;
            cargos.push(cargo);
          });
          // eslint-disable-next-line array-callback-return
          dataActa.catBeneficiado.map((v) => {
            beneficiado = {};
            catIdContabilidad = {};
            catIdContabilidad.id = v.idContabilidad;
            catIdContabilidad.nombre = v.idContabilidad;
            catIdContabilidades.push(catIdContabilidad);
            beneficiado.id = v.idSujetoObligado;
            beneficiado.nombre = v.sujetoObligado;
            catbeneficiados.push(beneficiado);
          });
          // eslint-disable-next-line array-callback-return
          dataActa.estados.map((o) => {
            if (o.idEstado === dataActa.idEntidad) {
              // eslint-disable-next-line array-callback-return
              o.municipios.map((s) => {
                municipio = {};
                municipio.id = s.idMunicipio;
                municipio.nombre = s.nombreMunicipio;
                municipios.push(municipio);
              });
            }
          });
          setMunicipios(municipios);
          // eslint-disable-next-line array-callback-return
          dataActa.catProceso.map((v) => {
            catProcesosElectoral = {};
            catProcesosElectoral.id = v.idProcesoElectoral;
            catProcesosElectoral.nombre = v.descripcion;
            catProcesosElectorales.push(catProcesosElectoral);
          });
          // eslint-disable-next-line array-callback-return
          catProcesosElectoralesEspe = dataActa.catProcesoEspesifico.map((v) => {
            catProcesosElectoralESpe = {};
            catProcesosElectoralESpe.id = v.idProcesoEspecifico;
            catProcesosElectoralESpe.nombre = v.nombreProcesoEspecifico;
            return catProcesosElectoralESpe;
          });

          // eslint-disable-next-line array-callback-return
          dataActa.catMedidas.map((v) => {
            medida = {};
            medida.id = v.idUnidadMedida;
            medida.nombre = v.descripcion;
            medidas.push(medida);
          });
          // eslint-disable-next-line array-callback-return
          dataActa.sujetosObligados.map((s) => {
            sujetosObligado = {};
            sujetosObligado.id = s.idSujetoObligado;
            sujetosObligado.nombre = s.sujetoObligado;
            sujetosObligados.push(sujetosObligado);
          });
          // eslint-disable-next-line array-callback-return
          dataActa.cathallazgo.map((s) => {
            catHallazgo = {};
            catHallazgo.id = s.idHallazgo;
            catHallazgo.nombre = s.nombreHallazgo;
            catHallazgos.push(catHallazgo);
          });
          atr = '';
          // eslint-disable-next-line array-callback-return
          dataActa.cathallazgo.map((x) => {
            if (dataActa.idTipoHallazgo === x.idHallazgo) {
              atr = x.atributos;
              setatributos(x.atributos);
            }
          });
          // eslint-disable-next-line array-callback-return
          dataActa.estados.map((n) => {
            // eslint-disable-next-line eqeqeq
            if (n.idEstado == dataActa.idEntidad) {
              // eslint-disable-next-line array-callback-return
              n.municipios.map((m) => {
                // eslint-disable-next-line eqeqeq
                if (m.idMunicipio == dataActa.ubicacion.idMunicipio) {
                  Estado = m.idMunicipio;
                }
              });
              // eslint-disable-next-line array-callback-return
              n.distritosLocales.map((v) => {
                distrito = {};
                distrito.id = v.idDistrito;
                distrito.nombre = v.cabeceraDistrital;
                Distritos.push(distrito);
              });
              setcatDistritosL(Distritos);
              // eslint-disable-next-line array-callback-return
              n.distritosFederales.map((v) => {
                distritoF = {};
                distritoF.id = v.idDistrito;
                distritoF.nombre = v.cabeceraDistrital;
                DistritosF.push(distritoF);
              });
              setcatDistritosF(DistritosF);
            }
          });
          // eslint-disable-next-line array-callback-return
          dataActa.tipoBeneficios.map((t) => {
            // eslint-disable-next-line eqeqeq
            if (t.idTipoBeneficio == dataActa.tipoBeneficcio) {
              benefico = t.nombreTipoBeneficio;
            }
          });
          // eslint-disable-next-line array-callback-return
          dataActa.tipoAsociaciones.map((h) => {
            asociacion = {};
            asociacion.id = h.idTipoAsociacion;
            asociacion.nombre = h.tipoAsociacion;
            asociaciones.push(asociacion);
          });
          // eslint-disable-next-line array-callback-return
          dataActa.catMonitoreos.map((m) => {
            catmonitoreo = {};
            catmonitoreo.id = m.idTipoMonitoreo;
            catmonitoreo.nombre = m.tipoMonitoreo;
            monitoreos.push(monitoreo);
          });
          setbeneficio(dataActa.idTipoBeneficcio);
          if (dataActa.idTipoBeneficcio === 3 || dataActa.idTipoBeneficcio === 4) {
            setList(dataActa.beneficiados);
          }
          let aspirante = 0;
          asociaciones = [];
          let partidoPolitico = 0;
          let coalicion = 0;
          let precandidato = 0;
          let candidatoInde = 0;
          // eslint-disable-next-line array-callback-return
          dataActa.catBeneficiado.map((s) => {
            if (dataActa.idProcesoEspecifico === 2 && s.idProcesoSIMAC === 2) {
              asociacion = {};
              if (candidatoInde === 0 && s.idTipoAsociacion === 4) {
                candidatoInde += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
              if (coalicion === 0 && s.idTipoAsociacion === 3) {
                coalicion += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
              if (partidoPolitico === 0 && s.idTipoAsociacion === 1) {
                partidoPolitico += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
            }
            if (
              dataActa.idProcesoEspecifico === 1 &&
              s.idProcesoSIMAC === 1 &&
              s.idTipoAsociacion === 1
            ) {
              asociacion = {};
              if (precandidato === 0) {
                precandidato += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
            }
            if (dataActa.idProcesoEspecifico === 3 && s.idProcesoSIMAC === 3) {
              asociacion = {};
              if (aspirante === 0 && s.idTipoAsociacion === 4) {
                aspirante += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
            }
            if (
              dataActa.idProcesoEspecifico === 4 &&
              (s.idProcesoSIMAC === 3 || s.idProcesoSIMAC === 1)
            ) {
              asociacion = {};
              if (aspirante === 0 && s.idTipoAsociacion === 4) {
                aspirante += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
              if (precandidato === 0 && s.idTipoAsociacion === 1) {
                precandidato += 1;
                asociacion.id = s.idTipoAsociacion;
                asociacion.nombre = s.tipoAsociacion;
                asociacion.idTipoAsociacion = s.idTipoAsociacion;
                asociacion.idProcesoSIMAC = s.idProcesoSIMAC;
                asociacion.idEstado = s.idEstado;
                asociaciones.push(asociacion);
              }
            }
          });
          setSearchValue(1);
          form.setFieldsValue({
            entidad: dataActa.nombreEstado,
            tipoEleccion: dataActa.tipoEleccion,
            procesoEsp: dataActa.idTipoBeneficcio,
            proceso: dataActa.idProcesoEspecifico,
            ambito: dataActa.idAmbito,
            idTipoMedida:
              (dataActa.idTipoMedida === 19 || dataActa.idTipoMedida === 20) &&
              dataActa.idTipoMedida,
            // idTipoMedida: dataActa.idTipoMedida,
            motivoCancelacion: dataActa.motivoCancelacion,
            entidadHallazgo: dataActa.idDistritoLoc,
            distrito: dataActa.idDistritoLoc,
            distritoF: dataActa.idDistritoFed,
            tipoBeneficio: dataActa.idTipoBeneficcio,
            // beneficiados: dataActa.nombreBeneficiado,
            idContabilidad: dataActa.idContabilidad,
            hallazgo: dataActa.idTipoHallazgo,
            idIne: dataActa.idINE,
            calle: dataActa.ubicacion.calle,
            numeroExterior: dataActa.ubicacion.numero,
            numeroJunta: dataActa.ubicacion.numeroJunta,
            colonia: dataActa.ubicacion.colonia,
            cp: dataActa.ubicacion.codigoPostal,
            entrecallesP: dataActa.ubicacion.entreCalle1,
            entrecallesS: dataActa.ubicacion.entreCalle2,
            referencias: dataActa.ubicacion.referencias,
            longitud: dataActa.ubicacion.longitud,
            latitud: dataActa.ubicacion.latitud,
            municipio: dataActa.ubicacion.idMunicipio,
            ancho: dataActa.ancho,
            cargo: dataActa.beneficiados[0]?.cargo,
            sujetoObligado: dataActa.beneficiados[0]?.idSujetoObligado,
            alto: dataActa.alto,
            duracion: dataActa.duracion,
            tipoAsociacion: dataActa.idTipoAsociacion,
            estatus: dataActa.idestatus,
            // Datos hallazgo
            cantidad: dataActa.cantidad,
            tipoMedida: dataActa.tipoMedida,
            medida: dataActa.medida,
            duracionHr: dataActa.duracionHr,
            duracionMin: dataActa.duracionMin,
            duracionSg: dataActa.duracionSeg,
            lema: dataActa.lema,
            infoAdicional: dataActa.infAdicional,
            idProcesoElectoral: dataActa.idProcesoElectoral
          });
          if (dataActa.idAmbito === 1) {
            setValue(1);
            setrenderDistrito(1);
          }
          if (dataActa.idAmbito === 2) {
            setValue(2);
            setrenderDistrito(2);
          }
          if (dataActa.idAmbito === 3) {
            setValue(3);
            setrenderDistrito(3);
          }
          // eslint-disable-next-line no-use-before-define
          renderDtoHllazgos();
        }
        setBeneficiados(dataActa.beneficiados, dataActa.idTipoBeneficcio, form);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const CampoCancelado = () => {
    return (
      <Col span={5}>
        <Form.Item
          name="motivoCancelacion"
          label="Motivo de cancelación:"
          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
          <Input />
        </Form.Item>
      </Col>
    );
  };

  const hamdleCambioStatus = (e) => {
    if (e === 3) {
      sethallazgoCancelado(true);
    } else {
      sethallazgoCancelado(false);
    }
  };

  const handleCambioProceso = (e) => {
    // console.log(e);
  };

  const handleEliminarList = (record) => {
    let index = 190000;
    const newLista = [...list];
    newLista.forEach((registro, indice) => {
      if (registro.idContabilidad === record.idContabilidad) {
        index = indice;
      }
      const lsitaEliminados = [...sujetosEliminados];
      lsitaEliminados.push(record);
      setsujetosEliminados(lsitaEliminados);
      newLista.splice(index, 1);
      setList(newLista);
    });
  };

  const eleiminarRegistroPersanalizado = (record) => {
    return (
      <div className="column-acciones">
        <Button
          shape="circle"
          onClick={() => {
            handleEliminarList(record);
          }}
          icon={<DeleteOutlined className="icons-tbl-users" />}
        />
      </div>
    );
  };

  const handleEliminarList2 = (record) => {
    let index = 190000;
    const newLista = [...list];
    newLista.forEach((registro, indice) => {
      if (registro.idsujetoObligado === record.idsujetoObligado) {
        index = indice;
      }
      const lsitaEliminados = [...sujetosEliminados];
      lsitaEliminados.push(record);
      setsujetosEliminados(lsitaEliminados);
      newLista.splice(index, 1);
      setList(newLista);
    });
  };

  // --------------------------Sección Beneficiados------------------------------

  // Obtenemos el tamaño del navegador
  const windowSize = useScreenSize();
  // Lo asignamos para validar el tamaño maximo del tag y visualizar el toolTip
  const lengthMaxTag = windowSize.width < 1200 ? 15 : 25;

  // Método para agregar el sujeto obligado de forma manual
  const showInputSujetoObligado = (benef) => {
    const updatedBeneficiado = {
      ...benef,
      flag: 'so'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(true);
  };

  // Método para agregar el sujeto obligado de forma manual en beneficiados genericos y conjunto
  const showInputSujetoObligadoGenericoConjunto = (benef, idx) => {
    const updatedBeneficiado = {
      ...benef,
      flag: 'so'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(true);
  };

  // Método para agregar un cargo de forma manual
  const showInputCargo = (benef, idx) => {
    const updatedBeneficiado = {
      ...benef,
      flag: 'car'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(true);
  };

  // Método para cargar los tipos de asociación dependiendo del proceso específico
  const getTiposAsociacion = () => {
    // const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
    const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
      listaBeneficiados,
      dataActa.idProcesoEspecifico
    );
    setListTipoAsociacion(tiposAsociacionPorProcesoEspecifico);
  };

  // Método para obtener el catalogo de sujetos obligados
  // depenediendo del tipo de asociación seleccionada en el select
  const getSujetosObligados = (tipoAsociacionId, nombreAsociacion, infoBene) => {
    if (infoBene !== undefined) {
      const updatedBeneficiado = {
        ...infoBene,
        tipoAsociacion: nombreAsociacion.label,
        idTipoAsociacion: tipoAsociacionId
      };
      const updatedBeneficiadosList = [...infoBeneficiados];
      const indexToUpdated = updatedBeneficiadosList.findIndex(
        (b) =>
          b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
          b.idContabilidad === updatedBeneficiado.idContabilidad
      );
      updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
      form.setFieldsValue({
        beneficiados: updatedBeneficiadosList
      });
      setInfoBeneficiados(updatedBeneficiadosList);
    }

    const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
      listaBeneficiados,
      dataActa.idProcesoEspecifico
    );

    if (tipoAsociacionId !== 0) {
      const beneficiadosPorAsociacion = getBeneficiadosPorAsociacionId(
        tiposAsociacionPorProcesoEspecifico,
        tipoAsociacionId
      );
      const beneficiadosPorEntidad = beneficiadosPorAsociacion?.filter(
        (b) => b.idEstado === dataActa.idEntidad
      );
      const sujObligados = removeDuplicatesByProperty(
        beneficiadosPorEntidad.map((b) => ({
          sujetoObligado: b.sujetoObligado,
          idSujetoObligado: b.idSujetoObligado
        })),
        'idSujetoObligado'
      );
      const sujetosObligadosNuevo = sujObligados.map((so) =>
        Object.defineProperty(so, 'value', Object.getOwnPropertyDescriptor(so, 'sujetoObligado'))
      );
      setListSujetosObligados(sujetosObligadosNuevo);
    }
  };

  // Método para obtener los cargos dependiendo del proceso específico
  const getCargos = () => {
    // const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
    const cargosPorProcesoEspecifico = getCargosPorProcesoEspecifico(
      listaBeneficiados,
      dataActa.idProcesoEspecifico
    );
    const cargosPorProcesoEspecificoNuevo = cargosPorProcesoEspecifico.map((ca) =>
      Object.defineProperty(ca, 'value', Object.getOwnPropertyDescriptor(ca, 'cargo'))
    );
    setListCargos(cargosPorProcesoEspecificoNuevo);
  };

  // Método que se ejecuta dentro del hook para cargar
  // beneficiados al momento de editar un monitoreo
  const handleTagInBeneficiados = () => {
    const { beneficiados: bene } = form.getFieldValue();
    if (
      tags !== undefined &&
      infoBeneficiados !== undefined &&
      tags.length !== 0 &&
      infoBeneficiados.length !== 0
    ) {
      setTags([]);
      setInfoBeneficiados([]);
    }
    const nameTags = bene?.map((b) => {
      return b?.nombreBeneficiado;
    });

    if (bene?.length > 0 && listaBeneficiados?.length > 0) {
      const beneficiadosAgregados = new Set(bene.map((benefi) => benefi?.nombreBeneficiado));
      const beneficiadosRestantes = listaBeneficiados.filter(
        (benefi) => !beneficiadosAgregados.has(benefi.nombreBeneficiado)
      );
      setListaBeneficiados(beneficiadosRestantes);
    }
    setTags(nameTags);
    setInfoBeneficiados(bene);
  };

  // Método que se ejecuta dentro del hook para cargar
  // beneficiados genericos y conjunto al momento de editar un monitoreo
  const handleTagInBeneficiadosGenericosConjunto = () => {
    const { beneficiados: bene } = form.getFieldValue();
    if (tags.length !== 0 && infoBeneficiados.length !== 0) {
      setTags([]);
      setInfoBeneficiados([]);
    }
    const nameTags = bene.map((b) => {
      return b?.tipoAsociacion === 'PRECANDIDATO'
        ? 'PRECANDIDATO / PARTIDO POLITICO'
        : b?.tipoAsociacion;
    });
    setTags(nameTags);
    setInfoBeneficiados(bene);
  };

  // Método para remover nombres de beneficiadados que se encuantran en el array de tags
  const handleCloseTag = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    if (infoBeneficiados.length > 0) {
      const newInfoBeneficiados = infoBeneficiados.filter(
        (infoBen) => infoBen.nombreBeneficiado !== removedTag
      );
      form.setFieldsValue({
        beneficiados: newInfoBeneficiados
      });
      setInfoBeneficiados(newInfoBeneficiados);
    }
    if (removedTag !== undefined && beneficiadosList.length > 0) {
      const beneficiadoRemoved = beneficiadosList.find(
        (bene) => bene.nombreBeneficiado === removedTag
      );
      if (beneficiadoRemoved) {
        const updatedListaBeneficiado = [...listaBeneficiados];
        updatedListaBeneficiado.push(beneficiadoRemoved);
        setListaBeneficiados(updatedListaBeneficiado);
      }
    }
    setTags(newTags);
  };

  const handleCloseTagGenericoConjunto = (idx) => {
    const newTags = tags.toSpliced(idx, 1);
    if (infoBeneficiados.length > 0) {
      const newInfoBeneficiados = infoBeneficiados.toSpliced(idx, 1);
      form.setFieldsValue({
        beneficiados: newInfoBeneficiados
      });
      setInfoBeneficiados(newInfoBeneficiados);
    }
    setTags(newTags);
  };

  // Método para remover el sujeto obligado que se ingreso de forma manual
  // se ejecuta en el tag correspondiente (Tag de sujeto obligado)
  const handleCloseTagSujetoObligado = (removeSujetoObligado) => {
    const updatedBeneficiado = {
      ...removeSujetoObligado,
      sujetoObligado: ''
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  // Método para remover el sujeto obligado que se ingreso de forma manual
  // se ejecuta en el tag correspondiente (Tag de sujeto obligado)
  const handleCloseTagSujetoObligadoGenericoConjunto = (removeSujetoObligado, idx) => {
    getSujetosObligados(removeSujetoObligado.idTipoAsociacion, removeSujetoObligado.tipoAsociacion);
    const updatedBeneficiado = {
      ...removeSujetoObligado,
      sujetoObligado: '',
      idSujetoObligado: 0
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  // Método para remover el cargo que se ingreso de forma manual
  // se ejecuta en tag correspondiente (Tag de cargo)
  const handleCloseTagCargo = (removedCargo, idx) => {
    const updatedBeneficiado = {
      ...removedCargo,
      cargo: ''
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  const handleInputChange = (e) => {
    // console.log('Hola');
    setInputValue(e.target.value);
    setInputCargoVisible(true);
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado directo
  // que se muestraen la lista desplegable del autocomplete
  const handleInputSelectConfirmBenDirecto = (e, beneficiadoSelect) => {
    const updatedBeneficiado = {
      ...beneficiadoSelect,
      sujetoObligadoId: beneficiadoSelect.idSujetoObligado,
      beneficiado: beneficiadoSelect.idContabilidad
    };
    if (e !== '' && tags[0] !== '' && tags.length === 0) {
      setTags([...tags, e]);
    }

    if (e !== '' && tags[0] === '') {
      setTags([e]);
    }

    if (e !== '' && infoBeneficiados[0] !== undefined && infoBeneficiados.length === 0) {
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, updatedBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, updatedBeneficiado]);
    }

    if (e !== '' && infoBeneficiados[0] === undefined) {
      form.setFieldsValue({
        beneficiados: [updatedBeneficiado]
      });
      setInfoBeneficiados([updatedBeneficiado]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado personalizado
  // que se muestraen la lista desplegable del autocomplete
  const handleInputSelectConfirmBenPersonalizado = (e, beneficiadoSelect) => {
    const updatedBeneficiado = {
      ...beneficiadoSelect,
      sujetoObligadoId: beneficiadoSelect.idSujetoObligado,
      beneficiado: beneficiadoSelect.idContabilidad
    };
    if (e !== '' && tags[0] !== '' && tags.indexOf(e) === -1) {
      setTags([...tags, e]);
    }

    if (e !== '' && tags[0] === '') {
      setTags([e]);
    }

    if (
      e !== '' &&
      infoBeneficiados[0] !== undefined &&
      infoBeneficiados?.map((b) => b.nombreBeneficiado).indexOf(e) === -1
    ) {
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, updatedBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, updatedBeneficiado]);
    }

    if (e !== '' && infoBeneficiados[0] === undefined) {
      form.setFieldsValue({
        beneficiados: [updatedBeneficiado]
      });
      setInfoBeneficiados([updatedBeneficiado]);
    }

    if (beneficiadoSelect.nombreBeneficiado !== undefined) {
      const nuevaListaBeneficiados = listaBeneficiados.filter(
        (benefi) => benefi.nombreBeneficiado !== beneficiadoSelect.nombreBeneficiado
      );
      setListaBeneficiados(nuevaListaBeneficiados || []);
    }
    setInputVisible(false);
    setInputValue('');
  };

  // Metódo que se ejecuta cuando se selecciona un sujeto obligado
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmSujetoObligadoBeneficiado = (e, option, infoBene) => {
    const updatedBeneficiado = {
      ...infoBene,
      sujetoObligado: e,
      idSujetoObligado: option.idSujetoObligado,
      sujetoObligadoId: option.idSujetoObligado,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(false);
  };

  // Metódo que se ejecuta cuando se selecciona un sujeto obligado
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmSujetoObligadoBeneficiadoGenericoConjunto = (
    e,
    option,
    infoBene,
    idx
  ) => {
    const updatedBeneficiado = {
      ...infoBene,
      sujetoObligado: e,
      idSujetoObligado: option.idSujetoObligado,
      sujetoObligadoId: option.idSujetoObligado,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(false);
  };

  // Metódo que se ejecuta cuando se selecciona un cargo
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmCargoBeneficiado = (e, benef, idx) => {
    const updatedBeneficiado = {
      ...benef,
      cargo: e,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(false);
  };

  // Método que sirve para agregar beneficiados directos no registrados al momento de oprimir enter
  const handleInputConfirmBenDirecto = (e) => {
    const eventValue = e.target.value.toUpperCase() ?? e;
    // const { idProcesoEspecifico, idProcesoGral, idEstado, idDistritoFed, idAmbito } =
    //  form.getFieldsValue();

    // console.log('e: ', e);

    let dataBeneficiado = {};
    if (eventValue && tags.indexOf(eventValue) === -1 && tags.length === 0) {
      dataBeneficiado = {
        idBeneficiado: 0,
        flag: 'ini',
        nombreBeneficiado: eventValue,
        tipoAsociacion: '',
        idTipoAsociacion: 0,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: '',
        estatus: 1,
        idContabilidad: 0,
        beneficiado: 0,
        idProcesoSIMAC: dataActa.idProcesoEspecifico,
        idProcesoGral: dataActa.idProcesoElectoral,
        idEstado: dataActa.idEntidad,
        idDistritoFederal: dataActa.idDistritoFed,
        idAmbito: dataActa.idAmbito
      };
      setTags([...tags, eventValue]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }

    setInputVisible(false);
    setInputValue('');
  };

  // Método para agregar beneficiados personalizados no registrados al momento de oprimir enter
  const handleInputConfirmBenPersonalizado = (e) => {
    const eventValue = e.target.value.toUpperCase() ?? e;
    // const { idProcesoEspecifico, idProcesoGral, idEstado, idDistritoFed, idAmbito } =
    //  form.getFieldsValue();

    // console.log('e: ', e);

    let dataBeneficiado = {};
    if (eventValue && tags.indexOf(eventValue) === -1) {
      dataBeneficiado = {
        idBeneficiado: 0,
        flag: 'ini',
        nombreBeneficiado: eventValue,
        tipoAsociacion: '',
        idTipoAsociacion: 0,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: '',
        estatus: 1,
        idContabilidad: 0,
        beneficiado: 0,
        idProcesoSIMAC: dataActa.idProcesoEspecifico,
        idProcesoGral: dataActa.idProcesoElectoral,
        idEstado: dataActa.idEntidad,
        idDistritoFederal: dataActa.idDistritoFed,
        idAmbito: dataActa.idAmbito
      };
      setTags([...tags, eventValue]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado generico
  // mostrado en la lista de tipo de asociación
  const handleInputSelectConfirmBenGenerico = (e, tipoAsociacionSelecionada) => {
    // console.log('handleInputSelectConfirmBenGenerico: ', e);
    // console.log('tipoAsociacionSelecionada: ', tipoAsociacionSelecionada);
    let dataBeneficiado = {};
    if (e) {
      dataBeneficiado = {
        tipoAsociacion: tipoAsociacionSelecionada.label,
        idTipoAsociacion: e,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: ''
      };
      setTags([...tags, tipoAsociacionSelecionada.label]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }
  };

  // Método para ingresar un sujeto obligado que no se tiene registrado
  const handleInputConfirmSujetoObligadoBeneficiado = (e, benef) => {
    const updatedBeneficiado = {
      ...benef,
      sujetoObligado: e.target.value.toUpperCase(),
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(false);
  };

  // Método para ingresar un sujeto obligado que no se tiene registrado
  const handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto = (e, benef, idx) => {
    const updatedBeneficiado = {
      ...benef,
      sujetoObligado: e.target.value.toUpperCase(),
      idSujetoObligado: 0,
      sujetoObligadoId: 0,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(false);
  };

  // Método para editar el cargo del beneficiado no registrado
  const handleInputConfirmCargoBeneficiado = (e, benef) => {
    // console.log('asdsad');
    const updatedBeneficiado = {
      ...benef,
      cargo: e.target.value.toUpperCase(),
      flag: false
    };

    // console.log('updatedBeneficiado: ', updatedBeneficiado);
    // console.log('infoBeneficiados: ', infoBeneficiados);

    const updatedBeneficiadosList = [...infoBeneficiados];

    // console.log('updatedBeneficiadosList: ', updatedBeneficiadosList);

    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        (b.idContabilidad
          ? b.idContabilidad === updatedBeneficiado.idContabilidad
          : b.idSujetoObligado === updatedBeneficiado.idSujetoObligado)
    );

    // console.log('indexToUpdated: ', indexToUpdated);

    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(false);
  };

  // Autocomplete para beneficiado directos para mostrarlas opciones disponibles registradas en la base de datos
  // y filtradas mediante las palabras ingresadas en el input
  const inputAutocompleteBeneficiadoDirecto = (
    beneficiadosNuevo,
    beneficiadosPorProcesoEspecifico,
    idx
  ) => {
    const nombreBeneficiado = (
      <AutoComplete
        className="autocomplete"
        options={beneficiadosNuevo}
        // eslint-disable-next-line no-shadow
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={handleInputSelectConfirmBenDirecto}>
        <Input
          key={idx}
          className="input-autocomplete"
          ref={inputRef}
          placeholder="Seleccione Beneficiado"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={(e) => handleInputConfirmBenDirecto(e, beneficiadosPorProcesoEspecifico)}
          onPressEnter={(e) => handleInputConfirmBenDirecto(e, beneficiadosPorProcesoEspecifico)}
        />
      </AutoComplete>
    );
    return (
      <span key={idx} className="tag-container">
        {nombreBeneficiado}
      </span>
    );
  };

  // Autocomplete para beneficiado personalizados para mostrar las opciones disponibles registradas en la base de datos
  // y filtradas mediante las palabras ingresadas en el input
  const inputAutocompleteBeneficiadoPersonalizado = (
    beneficiadosNuevo,
    beneficiadosPorProcesoEspecifico,
    idx
  ) => {
    const nombreBeneficiado = (
      <AutoComplete
        className="autocomplete"
        options={beneficiadosNuevo}
        // eslint-disable-next-line no-shadow
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={handleInputSelectConfirmBenPersonalizado}>
        <Input
          key={idx}
          className="input-autocomplete"
          placeholder="Seleccione Beneficiado"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={(e) => handleInputConfirmBenPersonalizado(e, beneficiadosPorProcesoEspecifico)}
          onPressEnter={(e) =>
            handleInputConfirmBenPersonalizado(e, beneficiadosPorProcesoEspecifico)
          }
        />
      </AutoComplete>
    );
    return (
      <span key={idx} className="tag-container">
        {nombreBeneficiado}
      </span>
    );
  };

  // Select tipo de asociación mostrado en beneficiados generico y conjunto
  const selectBenGenericoConjunto = (tiposAsociacion, idx) => {
    const tipoAsociacionMostradas = (
      <Select
        key={idx}
        className="autocomplete"
        options={tiposAsociacion.map((tipoAsociacion) => ({
          label: tipoAsociacion.tipoAsociacion,
          value: tipoAsociacion.idTipoAsociacion
        }))}
        placeholder="Selecciona"
        onSelect={handleInputSelectConfirmBenGenerico}
        onChange={(v, label) => getSujetosObligados(v, label)}
      />
    );
    return (
      <span key={idx} className="tag-container">
        {tipoAsociacionMostradas}
      </span>
    );
  };

  // Método que muestra el tag con el nombre del beneficiado directo una vez seleccionado
  const forNomBeneficiadoDirecto = (tag, idx) => {
    const isLongTag = tag[idx] !== undefined ? tag[idx]?.length > lengthMaxTag : false;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTag(tag[idx]);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Método que muestra el tag del beneficiado personalizado una vez seleccionado
  const forNomBeneficiadoPersonalizado = (tag, idx) => {
    const isLongTag = tag[idx]?.length > lengthMaxTag;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTag(tag[idx]);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Método que muestra el tag para los tipos de beneficiado Generico y Conjunto
  const forTipoAsociacionGenericoConjunto = (tag, idx) => {
    const isLongTag = tag[idx] !== undefined ? tag[idx].length > lengthMaxTag : false;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTagGenericoConjunto(idx);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Tipo de asociación al seleccionar beneficiado registrado
  const forBenTipoAso = (infoBen, idx) => {
    const isLongTag =
      infoBen[idx]?.tipoAsociacion !== undefined
        ? infoBen[idx].tipoAsociacion.length > lengthMaxTag
        : false;
    let infoBeneficiadoElem;
    if (isLongTag) {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {infoBen[idx]?.tipoAsociacion !== undefined
              ? `${infoBen[idx].tipoAsociacion.slice(0, lengthMaxTag)}...`
              : ''}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {infoBen[idx]?.tipoAsociacion !== undefined ? infoBen[idx].tipoAsociacion : ''}
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.tipoAsociacion !== undefined ? infoBen[idx].tipoAsociacion : ''}
        key={idx}>
        {infoBen[idx]?.tipoAsociacion !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span>{infoBen[idx]?.tipoAsociacion !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Tipo de asociación seleccionada mediante un select cuando el beneficiado no esta registrado en la base
  const forBenTipoAsoManual = (infoBen, idx) => {
    const selectInfoBeneficiadoElem = (
      <Select
        key={idx}
        className="select-tipo-so"
        options={listTipoAsociacion.map((tipoAsociacion) => ({
          label: tipoAsociacion.tipoAsociacion,
          value: tipoAsociacion.idTipoAsociacion
        }))}
        placeholder="Selecciona"
        onChange={(v, label) => getSujetosObligados(v, label, infoBen[idx])}
      />
    );
    return infoBen[idx]?.tipoAsociacion !== undefined ? selectInfoBeneficiadoElem : '';
  };

  // Sujeto obligado cuando el beneficiado esta registrado en la base de datos
  const forBenSO = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.sujetoObligado !== undefined
        ? infoBen[idx].sujetoObligado.length > lengthMaxTag
        : false;
    if (infoBen[idx]?.idContabilidad === 0 && infoBen[idx]?.sujetoObligado !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagSujetoObligado(infoBen[idx]);
          }}>
          <span>
            {isLongTag
              ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag).toUpperCase()}...`
              : infoBen[idx].sujetoObligado}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.sujetoObligado !== undefined
                ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag).toUpperCase()}...`
                : infoBen[idx]?.sujetoObligado !== undefined
                ? infoBen[idx].sujetoObligado
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.sujetoObligado !== undefined ? infoBen[idx]?.sujetoObligado : ''}
        key={idx}>
        {infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Sujeto obligado manual o mediante selección precargada para sujeto obligado
  // en beneficiado Genérico o Conjunto
  const forBenSOGenericoConjunto = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.sujetoObligado !== undefined
        ? infoBen[idx].sujetoObligado.length > lengthMaxTag
        : false;
    if (infoBen[idx]?.sujetoObligado !== undefined && infoBen[idx]?.sujetoObligado !== '') {
      infoBeneficiadoElem = (
        <Tag
          key={idx}
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagSujetoObligadoGenericoConjunto(infoBen[idx], idx);
          }}>
          {isLongTag
            ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
            : infoBen[idx].sujetoObligado}
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag" key={idx}>
          {
            // eslint-disable-next-line no-nested-ternary
            isLongTag && infoBen[idx]?.sujetoObligado !== undefined
              ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
              : infoBen[idx]?.sujetoObligado !== undefined
              ? infoBen[idx].sujetoObligado
              : ''
          }
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.sujetoObligado !== undefined ? infoBen[idx]?.sujetoObligado : ''}
        key={idx}>
        {infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  const forSujetoObligadoManual = (infoBen, idx) => {
    const tagInputSujetoObligado =
      infoBen[idx].flag === 'so' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listSujetosObligados}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(v, option) =>
            handleInputSelectConfirmSujetoObligadoBeneficiado(v, option, infoBen[idx])
          }>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRefSO}
            type="text"
            onBlur={(e) => handleInputConfirmSujetoObligadoBeneficiado(e, infoBen[idx])}
            onPressEnter={(e) => handleInputConfirmSujetoObligadoBeneficiado(e, infoBen[idx])}
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputSujetoObligado(infoBen[idx])}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar sujeto obligado</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputSujetoObligado}
      </span>
    );
  };

  // Sujeto Obligado de forma manual y con lista de opciones para
  // beneficiados genericos y conjunto
  const forSujetoObligadoManualGenericoConjunto = (infoBen, idx) => {
    const tagInputSujetoObligado =
      infoBen[idx].flag === 'so' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listSujetosObligados}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(v, option) =>
            handleInputSelectConfirmSujetoObligadoBeneficiadoGenericoConjunto(
              v,
              option,
              infoBen[idx],
              idx
            )
          }>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRefSO}
            type="text"
            onBlur={(e) =>
              handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto(e, infoBen[idx], idx)
            }
            onPressEnter={(e) =>
              handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto(e, infoBen[idx], idx)
            }
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputSujetoObligadoGenericoConjunto(infoBen[idx], idx)}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar sujeto obligado</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputSujetoObligado}
      </span>
    );
  };

  // Se ingresa el cargo mediante un tag cuando el beneficiado esta
  // registrado en la base de datos
  const forBenCargo = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.cargo !== undefined ? infoBen[idx].cargo.length > lengthMaxTag : false;
    if (infoBen[idx]?.idContabilidad === 0 && infoBen[idx]?.cargo !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagCargo(infoBen[idx], idx);
          }}>
          <span>
            {isLongTag
              ? `${infoBen[idx].cargo.slice(0, lengthMaxTag).toUpperCase()}...`
              : infoBen[idx].cargo.toUpperCase()}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.cargo !== undefined
                ? `${infoBen[idx].cargo.slice(0, lengthMaxTag).toUpperCase()}...`
                : infoBen[idx]?.cargo !== undefined
                ? infoBen[idx].cargo.toUpperCase()
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip title={infoBen[idx]?.cargo !== undefined ? infoBen[idx]?.cargo : ''} key={idx}>
        {infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Se ingresa el cargo mediante un tag cuando el beneficiado esta
  // registrado en la base de datos
  const forBenCargoGenericoConjunto = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.cargo !== undefined ? infoBen[idx].cargo.length > lengthMaxTag : false;
    if (infoBen[idx]?.cargo !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagCargo(infoBen[idx], idx);
          }}>
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.cargo !== undefined
                ? `${infoBen[idx].cargo.slice(0, lengthMaxTag).toUpperCase()}...`
                : infoBen[idx]?.cargo !== undefined
                ? infoBen[idx].cargo.toUpperCase()
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip title={infoBen[idx]?.cargo !== undefined ? infoBen[idx]?.cargo : ''} key={idx}>
        {infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Se ingresa el cargo de forma manual cuando el usuario no esta registrado en base de datos
  const forBenCargoManual = (infoBen, idx) => {
    const tagInputCargo =
      infoBen[idx].flag === 'car' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listCargos}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(e) => handleInputSelectConfirmCargoBeneficiado(e, infoBen[idx], idx)}>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRef}
            type="text"
            onBlur={(e) => handleInputConfirmCargoBeneficiado(e, infoBen[idx], idx)}
            onPressEnter={(e) => handleInputConfirmCargoBeneficiado(e, infoBen[idx], idx)}
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputCargo(infoBen[idx], idx)}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar cargo</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputCargo}
      </span>
    );
  };

  // Id de contabilidad se ingresa un cero cuando el beneficiado no esta registrado en la base de datos
  const forBenIdConta = (infoBen, idx) => {
    const infoBeneficiadoElem = (
      <Tag className="tag-element-beneficio-directo">
        <Text>{infoBen[idx]?.idContabilidad !== undefined ? infoBen[idx].idContabilidad : ''}</Text>
      </Tag>
    );
    return (
      <span key={idx} className="tag-container">
        {infoBeneficiadoElem}
      </span>
    );
  };

  const buscarIdIneEstado = async () => {
    setLoading(true);
    const peticion = {
      idEstado: dataActa.idEntidad
    };
    const { success, response } = await dispatch(getCatalogIdINEByEdo(peticion));
    if (success) {
      setCatIdIne(response.data.idINEs);
    }
    setLoading(false);
  };

  // Hook para cargar la lista de beneficiados
  useEffect(() => {
    if (beneficiadosList.length > 0) {
      setListaBeneficiados(beneficiadosList);
    }
  }, []);

  // Hook para cargar el tipo de beneficiado inicial
  useEffect(() => {
    setTipoBeneficioSeleccionado(dataActa.idTipoBeneficcio);

    if (dataActa.idEntidad) {
      buscarIdIneEstado();
    }
  }, [renderBeneficiados]);

  // Hook para forzar el renderizado cuando el tipo de beneficio inicial no cambia
  useEffect(() => {
    setRenderBeneficiadosEdit(renderBeneficiados);
  }, [renderBeneficiados]);

  // Hook para cargar los beneficiados cuando se edita el monitoreo
  useEffect(() => {
    if (tipoBeneficioSelecionado === 2 || tipoBeneficioSelecionado === 3) {
      handleTagInBeneficiados();
    }
    if (tipoBeneficioSelecionado === 1 || tipoBeneficioSelecionado === 4) {
      handleTagInBeneficiadosGenericosConjunto();
    }
    getTiposAsociacion();
    getCargos();
  }, [tipoBeneficioSelecionado, renderBeneficiadosEdit]);

  // Hook que habilita el input reference en el tag correspondiente para ingresar
  // el cargo, sujeto obligado o el nombre del beneficiado
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
    if (inputSujetoObligadoVisible) {
      inputRefSO.current?.focus();
    }
    if (inputCargoVisible) {
      inputRef.current?.focus();
    }
    if (inputSujetoObligadoGenConjVisible) {
      inputRefSOGC.current?.focus();
    }
  }, [
    inputVisible,
    inputSujetoObligadoVisible,
    inputCargoVisible,
    inputSujetoObligadoGenConjVisible
  ]);

  const renderHeaders = (tipoBeneficio) => {
    if (tipoBeneficio === DIRECTO || tipoBeneficio === PERSONALIZADO)
      return (
        <Row
          gutter={24}
          className={
            form.getFieldValue('beneficiados')?.length === 0 && 'beneficiados-header-empty'
          }>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Beneficiados
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Cargo:
          </Col>
          <Col xs={3} className="beneficiados-header-tabla">
            <span>*</span>ID de contabilidad:
          </Col>
        </Row>
      );
    if (tipoBeneficio === GENERICO)
      return (
        <Row gutter={24}>
          <Col xs={7} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={7} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
        </Row>
      );
    if (tipoBeneficio === CONJUNTO)
      return (
        <Row gutter={24}>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Cargo:
          </Col>
        </Row>
      );
    return null;
  };

  const renderInput = (tipoBeneficio, field, index) => {
    // console.log('tipoBeneficio: ', tipoBeneficio, "field: ", field, ", index: ", index);
    if (tipoBeneficio === DIRECTO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={5}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const beneficiadosPorProcesoEspecifico = listaBeneficiados.filter(
                  (b) =>
                    b.idProcesoSIMAC === dataActa.idProcesoEspecifico &&
                    b.idEstado === dataActa.idEntidad
                );
                const beneficiadosNuevo = beneficiadosPorProcesoEspecifico.map((b) =>
                  Object.defineProperty(
                    b,
                    'value',
                    Object.getOwnPropertyDescriptor(b, 'nombreBeneficiado')
                  )
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'nombreBeneficiado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados?.length === 0
                      ? inputAutocompleteBeneficiadoDirecto(
                          beneficiadosNuevo,
                          beneficiadosPorProcesoEspecifico,
                          index
                        )
                      : forNomBeneficiadoDirecto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {/* shouldUpdate Se agrega para que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del tag, el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idBeneficiado === 0
                      ? forBenTipoAsoManual(infoBeneficiados, index)
                      : forBenTipoAso(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManual(infoBeneficiados, index)
                      : forBenSO(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index].cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargo(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={3}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'idContabilidad']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad !== undefined
                      ? forBenIdConta(infoBeneficiados, index)
                      : ''}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === PERSONALIZADO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={5}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const beneficiadosPorProcesoEspecifico = listaBeneficiados.filter(
                  (b) =>
                    b.idProcesoSIMAC === dataActa.idProcesoEspecifico &&
                    b.idEstado === dataActa.idEntidad
                );
                const beneficiadosNuevo = beneficiadosPorProcesoEspecifico.map((b) =>
                  Object.defineProperty(
                    b,
                    'value',
                    Object.getOwnPropertyDescriptor(b, 'nombreBeneficiado')
                  )
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'nombreBeneficiado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.nombreBeneficiado === undefined
                      ? inputAutocompleteBeneficiadoPersonalizado(
                          beneficiadosNuevo,
                          beneficiadosPorProcesoEspecifico,
                          index
                        )
                      : forNomBeneficiadoPersonalizado(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del tag pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idBeneficiado === 0
                      ? forBenTipoAsoManual(infoBeneficiados, index)
                      : forBenTipoAso(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManual(infoBeneficiados, index)
                      : forBenSO(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index].cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargo(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={3}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'idContabilidad']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad !== undefined
                      ? forBenIdConta(infoBeneficiados, index)
                      : ''}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === GENERICO || !tipoBeneficio) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={7}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
                  listaBeneficiados,
                  dataActa.idProcesoEspecifico
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados?.length === 0
                      ? selectBenGenericoConjunto(tiposAsociacionPorProcesoEspecifico, index)
                      : forTipoAsociacionGenericoConjunto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={7}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManualGenericoConjunto(infoBeneficiados, index)
                      : forBenSOGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === CONJUNTO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
                  listaBeneficiados,
                  dataActa.idProcesoEspecifico
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.tipoAsociacion === undefined
                      ? selectBenGenericoConjunto(tiposAsociacionPorProcesoEspecifico, index)
                      : forTipoAsociacionGenericoConjunto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={6}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManualGenericoConjunto(infoBeneficiados, index)
                      : forBenSOGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={6}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargoGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const handleChange = (v) => {
    setListaBeneficiados(beneficiadosList);
    setTags([]);
    setInfoBeneficiados([]);
    setTipoBeneficioSeleccionado(v);
    setbeneficio(v);
    form.setFieldsValue({ beneficiados: [] });
    form.resetFields(['beneficiados']);
  };
  // --------------------------Sección Beneficiados------------------------------

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      } catch (error) {
        console.log('Error', error.message);
        reject(error);
      }
    });

  const handleFound = async () => {
    try {
      const fields = await form.validateFields();

      if (fields.beneficiados?.length === 0) {
        setActiveKey(['3']);
        dispatch(showAlert('Debes registrar al menos un beneficiado', ALERT_ERROR_TYPE));
        return;
      }
      if (fileList.length + muestrasList.length < 2) {
        setActiveKey(['1']);
        dispatch(showAlert('Debes registrar al menos dos muestras', ALERT_ERROR_TYPE));
        return;
      }
      setLoading(true);

      const municipiosB = entidades.find((e) => e.nombreEstado == fields.entidad)?.municipios || [];

      if (fields.estatus !== 4) {
        // eslint-disable-next-line no-unused-vars
        setLoading(true);
        ubicacion = {};
        fiscalizacion = {};
        hallazgo.muestras = [];
        fisca = [];
        let i = 0;
        let u = 0;
        // ubicacion
        ubicacion.calle = !fields.calle ? null : fields.calle;
        // if (fields.calle !== undefined) {
        //   ubicacion.calle = fields.calle;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        c = 1;
        ubicacion.colonia = fields.colonia ? fields.colonia : null;
        // if (fields.colonia !== undefined) {
        //   ubicacion.colonia = fields.colonia;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.codigoPostal = fields.cp ? fields.cp : null;
        // if (fields.cp !== undefined) {
        //   ubicacion.codigoPostal = fields.cp;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.entreCalle1 = fields.entrecallesP ? fields.entrecallesP : null;
        ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        // if (fields.entrecallesP !== undefined) {
        //   ubicacion.entreCalle1 = fields.entrecallesP;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.entreCalle2 = fields.entrecallesS ? fields.entrecallesS : null;
        // if (fields.entrecallesS !== undefined) {
        //   ubicacion.entreCalle2 = fields.entrecallesS;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.numero = fields.numeroExterior ? fields.numeroExterior : null;
        // if (fields.numeroExterior !== undefined) {
        //   ubicacion.numero = fields.numeroExterior;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.referencias = fields.referencias ? fields.referencias : null;
        // if (fields.referencias !== undefined) {
        //   ubicacion.referencias = fields.referencias;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        if (fields.municipio !== undefined) {
          if (typeof fields.municipio === 'string') {
            var municipioEncontrado = municipiosB.find(
              (x) => x.nombreMunicipio === fields.municipio
            );
            ubicacion.idMunicipio = municipioEncontrado ? municipioEncontrado.idMunicipio : 0;
          } else {
            // Acción si municipio es un número
            ubicacion.idMunicipio = fields.municipio;
          }
          c = 1;
          u = 1;
        } else fields.municipio = null;

        if (fields.latitud !== undefined) {
          ubicacion.latitud = fields.latitud;
          ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
          ubicacion.pkUbiHallazgo = 13;
          c = 1;
          u = 1;
        }
        if (fields.longitud !== undefined) {
          ubicacion.longitud = fields.longitud;
          ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
          ubicacion.pkUbiHallazgo = 13;
          c = 1;
          u = 1;
        }
        hallazgo.ubicacion = ubicacion;
        // if (u === 1) {
        //   hallazgo.ubicacion = ubicacion;
        // }
        hallazgo.idDistritoFed = fields.distritoF;
        // if (fields.distritoF !== undefined) {
        //   hallazgo.idDistritoFed = fields.distritoF;
        // }
        hallazgo.idDistritoLoc = fields.distrito;
        // if (fields.distrito !== undefined) {
        //   hallazgo.idDistritoLoc = fields.distrito;
        // }
        if (fields.tipoBeneficio !== undefined) {
          hallazgo.tipoBeneficio = fields.tipoBeneficio;
        }

        // console.log('beneficioActa: ', beneficioActa);

        // Sujeto Obligado
        beneficiados = {};
        if (beneficioActa === 1) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );

          // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
          hallazgo.beneficiados.forEach((element) => {
            if (element.estatus != 0) {
              element.estado = '';
              element.idMunicipio = null;
              element.municipio = '';
              element.nombreBeneficiado = '';
              element.idContabilidad = 0;
            }
          });
        }
        if (beneficioActa === 2) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }
        if (beneficioActa === 3) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }
        if (beneficioActa === 4) {
          const beneficiadosAgregados = fields.beneficiados.map((beneficiado) => ({
            ...beneficiado,
            idContabilidad: beneficiado.idSujetoObligado
          }));

          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }
        hallazgo.idAmbito = fields?.ambito;
        // if (fields.ambito !== undefined) {
        //   hallazgo.idAmbito = fields.ambito;
        //   c = 1;
        // }
        if (fields.hallazgo !== undefined) {
          hallazgo.idTipoHallazgo = fields.hallazgo;
          // eslint-disable-next-line array-callback-return
          catHallazgos.map((v) => {
            if (v.id === fields.hallazgo) {
              hallazgo.nombre = v.nombre;
              hallazgo.tipoHallazgo = v.nombre;
            }
          });
        }
        // Atributos Hallazgo
        hallazgo.idINE = fields?.idIne;
        // if (fields.idIne !== undefined && idIneImput) {
        //   hallazgo.idINE = fields.idIne;
        //   // hallazgo.idINE = fields.idIne;
        //   i += 1;
        // } else {
        //   hallazgo.idINE = null;
        // }
        hallazgo.idTipoMedida = !fields.idTipoMedida ? null : fields.idTipoMedida;
        hallazgo.medida = fields.medida;

        // if (fields.medida !== undefined && atrMedida) {
        //   hallazgo.medida = fields.medida;
        //   c = 1;
        // }
        hallazgo.duracionHr = parseInt(fields.duracionHr, 10);
        // if (fields.duracionHr !== undefined && atrduracionHr) {
        //   hallazgo.duracionHr = parseInt(fields.duracionHr, 10);
        //   c = 1;
        // }
        hallazgo.duracionMin = parseInt(fields.duracionMin, 10);
        // if (fields.duracionMin !== undefined && atrduracionMin) {
        //   hallazgo.duracionMin = parseInt(fields.duracionMin, 10);
        //   c = 1;
        // }
        hallazgo.duracionSeg = parseInt(fields.duracionSg, 10);
        // if (fields.duracionSg !== undefined && atrduracionSeg) {
        //   hallazgo.duracionSeg = parseInt(fields.duracionSg, 10);
        //   c = 1;
        // }
        hallazgo.campaniaAnterior = atrcampaniaAnteriorUse;

        hallazgo.cantidad = parseInt(fields.cantidad, 10);
        // if (fields.cantidad !== undefined && atrCantidad) {
        //   hallazgo.cantidad = parseInt(fields.cantidad, 10);
        //   c = 1;
        // } else {
        //   hallazgo.cantidad = null;
        // }
        hallazgo.alto = fields.alto;
        // if (fields.alto !== undefined) {
        //   hallazgo.alto = fields.alto;
        //   c = 1;
        // }
        hallazgo.ancho = fields.ancho;
        // if (fields.ancho !== undefined) {
        //   hallazgo.ancho = fields.ancho;
        //   c = 1;
        // }
        hallazgo.lema = fields.lema;
        // if (fields.lema !== undefined && atrLema) {
        //   hallazgo.lema = fields.lema;
        //   c = 1;
        // }
        hallazgo.placas = fields.placas;
        // if (fields.placas !== undefined && atrPlacas) {
        //   hallazgo.placas = fields.placas;
        //   c = 1;
        // }
        hallazgo.infAdicional = fields.infoAdicional;
        // if (fields.infoAdicional !== undefined && atrinfoAdicional) {
        //   hallazgo.infAdicional = fields.infoAdicional;
        //   c = 1;
        // }
        if (muestrasList.length > 0) {
          // eslint-disable-next-line array-callback-return
          muestrasList.map((v) => {
            if (v.tipoMuestra) {
              muestrasImagen = {};
              // if (v.thumbUrl) {
              let imagen;
              if (v.tipoMuestra === 4) {
                muestrasImagen.muestra = v.originFileObj.fullBase64Img?.split(',')[1];
                muestrasImagen.tipoMuestra = v.tipoMuestra;
                muestrasImagen.pkMuestra = 13;
                hallazgo.muestras.push(muestrasImagen);
                c = 1;
              } else {
                imagen = v.originFileObj.fullBase64Img?.split(',')[1];
                muestrasImagen.muestra = imagen;
                muestrasImagen.tipoMuestra = v.tipoMuestra;
                muestrasImagen.pkMuestra = 13;
                hallazgo.muestras.push(muestrasImagen);
                c = 1;
              }
              // }
            }
          });
        }
        if (imagenesEliminadas.length > 0) {
          // eslint-disable-next-line array-callback-return
          imagenesEliminadas.map((v) => {
            muestrasImagen = {};
            muestrasImagen.muestra = v.url;
            muestrasImagen.idMuestra = v.uid;
            muestrasImagen.estatus = 0;
            muestrasImagen.pkMuestra = 13;
            hallazgo.muestras.push(muestrasImagen);
            c = 1;
          });
        }
        if (fields.estatus === 3) {
          hallazgo.motivoCancelacion = fields.motivoCancelacion;
        }
        // Guardar cambios de Proceso Específico
        if (fields.proceso != null) {
          // Agregamos el valor de idProcesoEspecifico
          hallazgo.idProcesoEspecifico = fields.proceso;
        }

        var monitoreos = {};

        // Guardar cambios de Proceso Gral
        if (fields.idProcesoElectoral != null) {
          // Agregamos el valor de idProcesoGral
          monitoreos = {
            idProcesoGral: fields.idProcesoElectoral,
            idMonitoreo: dataActa.idMonitoreo,
            pkMonitoreo: 1,
            tipoRegistro: 1,
            idTipoMonitoreo: 1,
            descripcionProcesoGral:
              catalogos.data.procesosElectorales?.find(
                (p) => p.idProcesoElectoral === fields.idProcesoElectoral
              )?.descripcion || '',
            idTipoEleccion:
              catalogos.data.procesosElectorales?.find(
                (p) => p.idProcesoElectoral === fields.idProcesoElectoral
              )?.idTipoEleccion || ''
          };

          // hallazgo.idProcesoGral = fields.idProcesoElectoral;
        }

        hallazgo.estatus = fields.estatus;
        monitoreo.acta = acta;

        if (c > 0 || i > 0) {
          try {
            hallazgo.idHallazgo = dataActa.idHallazgo;
            hallazgo.idMonitoreo = dataActa.idMonitoreo;
            // const coki = new Cookie();
            // eslint-disable-next-line no-unused-vars
            // const respuesta = coki.get('JWT-TOKEN-SIMAC');
            const peticion = {
              token: '',
              hallazgos: {
                toDelete: [],
                toUpdate: [],
                toValidate: [],
                toCancel: [],
                toSave: []
              },
              monitoreos: {
                toUpdate: []
              }
            };
            // peticion.token = respuesta;
            peticion.hallazgos.toUpdate.push(hallazgo);

            peticion.monitoreos.toUpdate.push(monitoreos);
            // console.log('PETICION:::', peticion);

            // const { success, response } = await actasService.updateHallazgo(peticion);
            // const { success, response } = await dispatch(updateMonitoreo(peticion));
            const { data } = await actasService.updateHallazgo(peticion);
            if (data.code === 200) {
              // eslint-disable-next-line no-param-reassign
              dataActa.idAmbito = hallazgo.idAmbito;
              // setTimeout(() => {
              //   messageApi.open({
              //     type: 'success',
              //     content: 'Guardado exitosamente'
              //   });
              // }, 3000);
              call(+1);
              setIsVisibleSuccessModal(true);

              // MNI - ===> Aqupi va el cambio, llamado a los PDF
              // Variable a enviar para generar PDF del monitoreo
              let monitoreoPDF = [
                {
                  idMonitoreo: dataActa.idMonitoreo,
                  idTipoMonitoreo: 1, // 1 MONITOREOS_ESPECTACULARES
                  tiposActa: [{ id: 2, idsHallazgo: [dataActa.idHallazgo] }] // MNI - 2 Para Hallazgos
                }
              ];

              // Se genera PDF una vez que se han almacenado las Muestras
              let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

              if (generoPDF) {
                console.log('Se generó correctamente el PDF');
              } else {
                console.log('Error al generar el PDF');
              }
            } else {
              messageApi.open({
                type: 'error',
                content: 'La acción solicitada no se puede realizar, verifica la información'
              });
            }
          } catch (error) {
            console.log('error', error);
            messageApi.open({
              type: 'error',
              content: 'La acción solicitada no se puede realizar, verifica la información'
              // content: `${error}`
            });
          }
        }
        handleCancel();
      } else if (fields.estatus === 4 && dataActa.estatus !== 'Validado') {
        // eslint-disable-next-line no-unused-vars
        setLoading(true);
        ubicacion = {};
        fiscalizacion = {};
        hallazgo.muestras = [];
        fisca = [];
        const i = 0;
        let u = 0;
        // Ubicacion
        ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        ubicacion.calle = fields.calle ? fields.calle : null;
        // if (fields.calle !== undefined) {
        //   ubicacion.calle = fields.calle;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        // c = 1;
        ubicacion.colonia = fields.colonia ? fields.colonia : null;
        // if (fields.colonia !== undefined) {
        //   ubicacion.colonia = fields.colonia;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.codigoPostal = fields.cp ? fields.cp : null;
        // if (fields.cp !== undefined) {
        //   ubicacion.codigoPostal = fields.cp;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.entreCalle1 = fields.entrecallesP ? fields.entrecallesP : null;
        // if (fields.entrecallesP !== undefined) {
        //   ubicacion.entreCalle1 = fields.entrecallesP;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.entreCalle2 = fields.entrecallesS ? fields.entrecallesS : null;
        // if (fields.entrecallesS !== undefined) {
        //   ubicacion.entreCalle2 = fields.entrecallesS;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.numero = fields.numeroExterior ? fields.numeroExterior : null;
        // if (fields.numeroExterior !== undefined) {
        //   ubicacion.numero = fields.numeroExterior;
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.referencias = fields.referencias ? fields.referencias : null;
        // if (fields.referencias !== undefined) {
        //   ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
        //   ubicacion.referencias = fields.referencias;
        //   ubicacion.pkUbiHallazgo = 13;
        //   c = 1;
        //   u = 1;
        // }
        ubicacion.idMunicipio = fields.municipio ? fields.municipio : null;
        // if (fields.municipio !== undefined) {
        //   if (typeof fields.municipio === 'string') {
        //     var municipioEncontrado = municipiosB.find(
        //       (x) => x.nombreMunicipio === fields.municipio
        //     );
        //     ubicacion.idMunicipio = municipioEncontrado ? municipioEncontrado.idMunicipio : 0;
        //   } else {
        //     // Acción si municipio es un número
        //     ubicacion.idMunicipio = fields.municipio;
        //   }
        //   c = 1;
        //   u = 1;
        // }
        if (fields.latitud !== undefined) {
          ubicacion.latitud = fields.latitud;
          ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
          ubicacion.pkUbiHallazgo = 13;
          c = 1;
          u = 1;
        }
        if (fields.longitud !== undefined) {
          ubicacion.longitud = fields.longitud;
          ubicacion.idUbicacion = dataActa.ubicacion.idUbicacion;
          ubicacion.pkUbiHallazgo = 13;
          c = 1;
          u = 1;
        }
        hallazgo.ubicacion = ubicacion;
        // if (u === 1) {
        //   hallazgo.ubicacion = ubicacion;
        // }
        hallazgo.idDistritoFed = fields.distritoF ? fields.distritoF : null;
        // if (fields.distritoF !== undefined) {
        //   hallazgo.idDistritoFed = fields.distritoF;
        // }
        hallazgo.idDistritoLoc = fields.distrito ? fields.distrito : null;
        // if (fields.distrito !== undefined) {
        //   hallazgo.idDistritoLoc = fields.distrito;
        // }
        hallazgo.tipoBeneficio = fields.tipoBeneficio ? fields.tipoBeneficio : null;
        // if (fields.tipoBeneficio !== undefined) {
        //   hallazgo.tipoBeneficio = fields.tipoBeneficio;
        // }
        hallazgo.idAmbito = fields.ambito ? fields.ambito : null;
        // if (fields.ambito !== undefined) {
        //   hallazgo.idAmbito = fields.ambito;
        //   c = 1;
        // }
        hallazgo.idTipoHallazgo = fields.hallazgo ? fields.hallazgo : null;
        // if (fields.hallazgo !== undefined) {
        //   hallazgo.idTipoHallazgo = fields.hallazgo;
        //   // eslint-disable-next-line array-callback-return
        //   catHallazgos.map((v) => {
        //     if (v.id === fields.hallazgo) {
        //       hallazgo.nombre = v.nombre;
        //       hallazgo.tipoHallazgo = v.nombre;
        //     }
        //   });
        // }
        // Atributos Hallazgo
        hallazgo.idTipoMedida = fields.idTipoMedida ? fields.idTipoMedida : null;
        // if (fields.idTipoMedida !== undefined && atrTipoMedida) {
        //   hallazgo.idTipoMedida = fields.idTipoMedida;
        //   c = 1;
        // }
        hallazgo.medida = fields.medida ? fields.medida : null;
        // if (fields.medida !== undefined && atrMedida) {
        //   hallazgo.medida = fields.medida;
        //   c = 1;
        // }
        hallazgo.duracionHr = fields.duracionHr ? fields.duracionHr :null;
        // if (fields.duracionHr !== undefined && atrduracionHr) {
        //   hallazgo.duracionHr = fields.duracionHr;
        //   c = 1;
        // }
        hallazgo.duracionMin = fields.duracionMn ? parseInt(fields.duracionMn, 10) : null;
        // if (fields.duracionMn !== undefined && atrduracionMin) {
        //   hallazgo.duracionMin = parseInt(fields.duracionMn, 10);
        //   c = 1;
        // }
        hallazgo.duracionSeg = fields.duracionSg ? parseInt(fields.duracionSg, 10) : null;
        // if (fields.duracionSg !== undefined && atrduracionSeg) {
        //   hallazgo.duracionSeg = parseInt(fields.duracionSg, 10);
        //   c = 1;
        // }
        hallazgo.campañaAnterior = fields.campañaAnterior ? fields.campañaAnterior : null;
        // if (fields.campañaAnterior !== undefined && atrcampaniaAnterior) {
        //   hallazgo.campañaAnterior = fields.campañaAnterior;
        //   c = 1;
        // }
        // Atributos Hallazgo
        if (fields.idIne !== undefined && idIneImput) {
          hallazgo.idINE = fields.idIne;
          // hallazgo.idINE = fields.idIne;
          c = 1;
        } else {
          hallazgo.idINE = null;
        }
        hallazgo.cantidad = hallazgo.cantidad ? parseInt(fields.cantidad, 10) : null;
        // if (fields.cantidad !== undefined && atrCantidad) {
        //   hallazgo.cantidad = parseInt(fields.cantidad, 10);
        //   c = 1;
        // }
        hallazgo.lema = fields.lema ? fields.lema : null;
        // if (fields.lema !== undefined && atrLema) {
        //   hallazgo.lema = fields.lema;
        //   c = 1;
        // }
        hallazgo.placas = fields.placas ? fields.placas : null;
        // if (fields.placas !== undefined && atrPlacas) {
        //   hallazgo.placas = fields.placas;
        //   c = 1;
        // }
        hallazgo.infAdicional = fields.infoAdicional ? fields.infoAdicional : null;
        // if (fields.infoAdicional !== undefined && atrinfoAdicional) {
        //   hallazgo.infAdicional = fields.infoAdicional;
        //   c = 1;
        // }
        if (muestrasList.length > 0) {
          // eslint-disable-next-line array-callback-return
          muestrasList.map((v) => {
            if (v.tipoMuestra) {
              muestrasImagen = {};
              if (v.thumbUrl) {
                const imagen = v.thumbUrl.substring(22);
                muestrasImagen.muestra = imagen;
                muestrasImagen.tipoMuestra = v.tipoMuestra;
                muestrasImagen.pkMuestra = 13;
                hallazgo.muestras.push(muestrasImagen);
                c = 1;
              }
            }
          });
        }
        if (imagenesEliminadas.length > 0) {
          // eslint-disable-next-line array-callback-return
          imagenesEliminadas.map((v) => {
            muestrasImagen = {};
            muestrasImagen.muestra = v.url;
            muestrasImagen.idMuestra = v.uid;
            muestrasImagen.estatus = 0;
            muestrasImagen.pkMuestra = 13;
            hallazgo.muestras.push(muestrasImagen);
            c = 1;
          });
        }
        if (fields.estatus === 3) {
          hallazgo.motivoCancelacion = fields.motivoCancelacion;
        }
        hallazgo.estatus = fields.estatus;
        monitoreo.acta = acta;

        // Sujeto Obligado
        beneficiados = {};
        if (beneficioActa === 1) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );

          // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
          hallazgo.beneficiados.forEach((element) => {
            if (element.estatus != 0) {
              element.estado = '';
              element.idMunicipio = null;
              element.municipio = '';
              element.nombreBeneficiado = '';
              element.idContabilidad = 0;
            }
          });
        }
        if (beneficioActa === 2) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }
        if (beneficioActa === 3) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }
        if (beneficioActa === 4) {
          const beneficiadosAgregados = fields.beneficiados;
          hallazgo.beneficiados = newFormatBeneficiados(
            beneficiadosAgregados,
            dataActa.catBeneficiado,
            dataActa.idProcesoEspecifico,
            dataActa.beneficiados
          );
        }

        if (c > 0 || i > 0) {
          try {
            hallazgo.idHallazgo = dataActa.idHallazgo;
            hallazgo.idMonitoreo = dataActa.idMonitoreo;
            // const coki = new Cookie();
            // eslint-disable-next-line no-unused-vars
            // const respuesta = coki.get('JWT-TOKEN-SIMAC');
            const peticion = {
              token: '',
              hallazgos: {
                toDelete: [],
                toUpdate: [],
                toValidate: [],
                toCancel: [],
                toSave: []
              }
            };
            // peticion.token = respuesta;
            peticion.hallazgos.toUpdate.push(hallazgo);
            const { data } = await actasService.updateHallazgo(peticion);
            if (data.code === 200) {
              // eslint-disable-next-line no-param-reassign
              dataActa.idAmbito = hallazgo.idAmbito;
              call(+1);
              setIsVisibleSuccessModal(true);

              // MNI - ===> Aqupi va el cambio, llamado a los PDF

              // Variable a enviar para generar PDF del monitoreo
              let monitoreoPDF = [
                {
                  idMonitoreo: dataActa.idMonitoreo,
                  idTipoMonitoreo: 1, // 1 MONITOREOS_ESPECTACULARES
                  tiposActa: [{ id: 2, idsHallazgo: [dataActa.idHallazgo] }] // MNI - 2 Para Hallazgos
                }
              ];

              // Se genera PDF una vez que se han almacenado las Muestras
              let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

              if (generoPDF) {
                console.log('Se generó correctamente el PDF');
              } else {
                console.log('Error al generar el PDF');
              }
            } else {
              messageApi.open({
                type: 'error',
                content: 'No pudo ser guardado'
              });
            }
          } catch (error) {
            messageApi.open({
              type: 'error',
              content: `${error}`
            });
          }
        }
        handleCancel();
      } else if (fields.estatus === 4 && dataActa.estatus === 'Validado') {
        messageApi.open({
          type: 'error',
          content: 'No puede ser editado un hallazgo validado'
        });
        handleCancel();
      }
    } catch (error) {
      console.log(error);
      const { errorFields } = error;
      if (errorFields) scrollToErrorField(errorFields, form);
      if (errorFields?.length > 0) {
        const datosGenerales = ['ambito', 'distrito', 'distritoF'];
        const camposHallazgo = [
          'hallazgo',
          'cantidad',
          'idTipoMedida',
          'medida',
          'lema',
          'placas',
          'idIne'
        ];
        const camposUbicacion = [
          'municipio',
          'calle',
          'numeroExterior',
          'colonia',
          'cp',
          'referencias'
        ];
        const camposBeneficiado = ['tipoBeneficio'];
        errorFields.some((err) => {
          if (camposHallazgo.includes(err.name[0])) {
            setActiveKey(['4']);
            return true;
          }
          if (camposUbicacion.includes(err.name[0])) {
            setActiveKey(['5']);
            return true;
          }
          if (datosGenerales.includes(err.name[0])) {
            setActiveKey(['2']);
            return true;
          }
          if (camposBeneficiado.includes(err.name[0])) {
            setActiveKey(['3']);
            return true;
          }
          return false;
        });
        if (errorFields[0].name[0] === 'beneficiados') {
          setActiveKey(['3']);
        }
      }
    }
  };

  const handleRemove = (file) => {
    setMuestrasList(muestrasList.filter((muestra) => muestra.uid !== file.uid));
  };
  const handleCharge = ({ fileList: newFileList }) => {
    let isDeleting = false;
    // eslint-disable-next-line array-callback-return
    fileList.map((v) => {
      if (v.status === 'removed') {
        imagenesEliminadas.push(v);
        isDeleting = true;
      }
    });
    if (newFileList.length > 0 && !isDeleting) {
      // eslint-disable-next-line no-param-reassign
      newFileList[0].status = 'done';
      if (newFileList[0].type === 'image/jpg') {
        // eslint-disable-next-line no-param-reassign
        newFileList[0].tipoMuestra = 1;
      }
      if (newFileList[0].type === 'image/jpeg') {
        // eslint-disable-next-line no-param-reassign
        newFileList[0].tipoMuestra = 2;
      }
      if (newFileList[0].type === 'image/png') {
        // eslint-disable-next-line no-param-reassign
        newFileList[0].tipoMuestra = 3;
      }
      if (newFileList[0].type === 'video/mp4') {
        // eslint-disable-next-line no-param-reassign
        newFileList[0].tipoMuestra = 4;
        const fileThumbUrl = newFileList[0];
        fileThumbUrl.thumbUrl = imgDefaultVideo;
      }
      setMuestrasList((prevList) => [...prevList, newFileList[0]]);
    } else if (isDeleting) {
      setFileList(fileList.filter((item) => item.status !== 'removed'));
    }
  };

  // const renderBeneficioBeneficio = (e) => {
  //   setbeneficio(e);
  //   // renderBeneficio();
  // };
  const cambioImagnes = (imagenes) => {
    // eslint-disable-next-line array-callback-return
    imagenes.map((n) => {
      codeUploadFile = {};
      codeUploadFile.uid = n.idMuestra;
      codeUploadFile.name = `${n.idMuestra}image.png`;
      codeUploadFile.status = 'done';
      codeUploadFile.url =
        n.tipoMuestra === 4
          ? `data:video/mp4;base64,${n.muestra}`
          : `data:image/png;base64,${n.muestra}`;
      codeUploadFile.thumbUrl =
        n.tipoMuestra === 4 ? `${imgDefaultVideo}` : `data:image/jpeg;base64,${n.muestra}`;
      UploadFileS.push(codeUploadFile);
    });
  };
  const [loadingImages, setLoadingImages] = useState(false);
  const peticionImagenes = async () => {
    try {
      setLoadingImages(true);
      const respuesta = await dispatch(
        getMuestrasByidMonitoreo({
          hallazgo: {
            idMonitoreo: dataActa.idMonitoreo,
            idHallazgo: dataActa.idHallazgo
          }
        })
      );
      if (respuesta.success) {
        // const { data } = await actasService.imagenesHallazgo(peticion);
        cambioImagnes(respuesta.response.data.hallazgo.muestras);
        if (respuesta.response.data.code === 200) {
          setFileList(UploadFileS);
          setConter(corte + 1);
        }
      }
      setLoadingImages(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!open || !dataActa) return;
    if (corte === 0) {
      initAPP();
      if (open) {
        // eslint-disable-next-line array-callback-return
        dataActa.cathallazgo.map((x) => {
          if (dataActa.idTipoHallazgo === x.idHallazgo) {
            atr = x.atributos;
            setatributos(x.atributos);
          }
        });
      }
      // renderBeneficio();
      if (open) {
        peticionImagenes();
      }
    }
  }, [dataActa]);

  useEffect(() => {
    const listaAtributos =
      tipoHallazgos
        .find((tipo) => tipo.idHallazgo === form.getFieldsValue()?.hallazgo)
        ?.atributos?.split(',') || [];

    setrenderString('asdasd');
    setatributos(atr);
    if (listaAtributos.includes(findAtributoByName('idTipoMedida'))) {
      // buscarIdIneEstado(e);
      setrenderString('asdasd');
      setatrTipoMedida(true);
      setatrMedida(true);
    } else {
      setatrTipoMedida(false);
      setatrMedida(false);
    }
    if (listaAtributos.includes(findAtributoByName('medida'))) {
      setatrTipoMedida(true);
      setatrMedida(true);
    } else {
      setatrTipoMedida(false);
      setatrMedida(false);
    }
    if (listaAtributos.includes(findAtributoByName('idINE'))) {
      setidIneImput(true);
    } else {
      setidIneImput(false);
    }
    if (listaAtributos.includes(findAtributoByName('duracionHr'))) {
      setatrduracionHr(true);
    } else {
      setatrduracionHr(false);
    }
    if (listaAtributos.includes(findAtributoByName('duracionMin'))) {
      setatrduracionMin(true);
    } else {
      setatrduracionMin(false);
    }
    if (listaAtributos.includes(findAtributoByName('duracionSeg'))) {
      setatrduracionSeg(true);
    } else {
      setatrduracionSeg(false);
    }
    if (listaAtributos.includes(findAtributoByName('campaniaAnterior'))) {
      setatrcampaniaAnterior(true);
    } else {
      setatrcampaniaAnterior(false);
    }
    if (atributos?.search('40') !== -1) {
      setatrAlto(true);
    } else {
      setatrAlto(false);
    }
    if (atributos?.search('41') !== -1) {
      setatrAncho(true);
    } else {
      setatrAncho(false);
    }
    if (listaAtributos.includes(findAtributoByName('cantidad'))) {
      setatrCantidad(true);
    } else {
      setatrCantidad(false);
    }
    if (listaAtributos.includes(findAtributoByName('lema'))) {
      setatrLema(true);
    } else {
      setatrLema(false);
    }
    if (listaAtributos.includes(findAtributoByName('placas'))) {
      setatrPlacas(true);
    } else {
      setatrPlacas(false);
    }
    if (listaAtributos.includes(findAtributoByName('infAdicional'))) {
      setatrinfoAdicional(true);
    } else {
      setatrinfoAdicional(false);
    }
  }, [atr]);

  const propCampania = (e) => {
    if (e.target.checked) {
      setatrcampaniaAnteriorUse(1);
    } else {
      setatrcampaniaAnteriorUse(0);
    }
  };

  const tipoHallazgo = (e) => {
    // eslint-disable-next-line array-callback-return
    dataActa.cathallazgo.map((x) => {
      if (e === x.idHallazgo) {
        atr = x.atributos;
        setatributos(atr);
      }
    });
  };
  // eslint-disable-next-line consistent-return
  const renderDtoHllazgos = () => {
    let atributosRender = '';
    let Timehora = false;
    let duracionMin = false;
    let duracionSeg = false;
    let rcampaniaAnterior = false;
    let rCantidad = false;
    let rPlacas = false;
    let rLema = false;
    let rinfoAdicional = false;
    let rTipoMedida = false;
    let rMedida = false;
    if (open) {
      // eslint-disable-next-line array-callback-return
      dataActa.cathallazgo.map((x) => {
        if (dataActa.idTipoHallazgo === x.idHallazgo) {
          atributosRender = x.atributos;
        }
      });
      const str = '9,24,25,26,39,40,41,42,44,45,63';
      if (atributosRender.search(',9,') !== -1) {
        // buscarIdIneEstado();
        setrenderString('asdasd');
        rTipoMedida = true;
        rMedida = true;
      }
      if (atributosRender.search('24') !== -1) {
        Timehora = true;
      }
      if (atributosRender.search('15') !== -1) {
        rTipoMedida = true;
        rMedida = true;
      }
      if (atributosRender.search('16') !== -1) {
        rTipoMedida = true;
        rMedida = true;
      }
      if (atributosRender.search('17') !== -1) {
        rTipoMedida = true;
        rMedida = true;
      }
      if (atributosRender.search('25') !== -1) {
        duracionMin = true;
      }
      if (atributosRender.search('26') !== -1) {
        duracionSeg = true;
      }
      if (atributosRender.search('39') !== -1) {
        rcampaniaAnterior = true;
      }
      if (atributosRender.search('42') !== -1) {
        rCantidad = true;
      }
      if (atributosRender.search('44') !== -1) {
        rLema = true;
      }
      if (atributosRender.search('45') !== -1) {
        rPlacas = true;
      }
      if (atributosRender.search('63') !== -1) {
        rinfoAdicional = true;
      }
      return (
        <Row>
          {atrTipoMedida ? (
            <>
              <Col span={5}>
                <Form.Item name="idTipoMedida" label="Tipo medida">
                  <Select
                    fieldNames={{ value: 'idTipoMedida', label: 'tipoMedida' }}
                    optionFilterProp
                    placeholder="Filtra"
                    allowClear
                    options={dataActa.catMedida}
                  />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {atrMedida ? (
            <>
              <Col span={5}>
                <Form.Item name="medida" label="Medida">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {Timehora ? (
            <>
              <Col span={2}>
                <Form.Item
                  name="duracionHr"
                  label="        Duración"
                  rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
                  <SimpleNumericInput />
                </Form.Item>
              </Col>
              <Col span={1}>
                <div className="butonrender">&nbsp;</div>
                <span>Hrs</span>
              </Col>
              <Col span={2}>
                <Form.Item name="duracionMint" label=" ">
                  <SimpleNumericInput />
                </Form.Item>
              </Col>
              <Col span={1}>
                <div className="butonrender">&nbsp;</div>
                <span>Min</span>
              </Col>
              <Col span={2}>
                <Form.Item name="duracionSg" label=" ">
                  <SimpleNumericInput />
                </Form.Item>
              </Col>
              <Col span={1}>
                <div className="butonrender">&nbsp;</div>
                <span>Sg</span>
              </Col>
            </>
          ) : null}
          {rcampaniaAnterior ? (
            <>
              <Col span={10}>
                <Form.Item name="campañaAnterior" label=" ">
                  <Checkbox
                    defaultChecked={atrCampaniaAnteriorCheck}
                    onChange={(e) => propCampania(e)}>
                    ¿Es propaganda de campaña anterior?
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {rCantidad ? (
            <>
              <Col span={5}>
                <Form.Item
                  name="cantidad"
                  label="Cantidad"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {rLema ? (
            <>
              <Col span={5}>
                <Form.Item
                  name="lema"
                  label="Lema"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {rPlacas ? (
            <>
              <Col span={5}>
                <Form.Item
                  name="placas"
                  label="Placas"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
          {rinfoAdicional ? (
            <>
              <Col span={12}>
                <Form.Item
                  name="infoAdicional"
                  label="Información adicional (modo, tiempo, lugar):"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <TextArea rows={2} showCount maxLength={1200} placeholder="Escribe.." />
                </Form.Item>
              </Col>
              <Col span={1} />
            </>
          ) : null}
        </Row>
      );
    }
  };

  const renderDtoHllazgos2 = (e) => {
    const listaAtributos =
      tipoHallazgos
        .find((tipo) => tipo.idHallazgo === form.getFieldsValue()?.hallazgo)
        ?.atributos?.split(',') || [];

    if (open) {
      tipoHallazgo(e);
      // eslint-disable-next-line array-callback-return
      dataActa.cathallazgo.map((x) => {
        if (e === x.idHallazgo) {
          atr = x.atributos;
          setatributos(atr);
        }
      });
      if (listaAtributos.includes(findAtributoByName('idTipoMedida'))) {
        // buscarIdIneEstado(e);
        setrenderString('asdasd');
        setatrTipoMedida(true);
        setatrMedida(true);
      } else {
        setatrTipoMedida(false);
        setatrMedida(false);
      }
      if (listaAtributos.includes(findAtributoByName('medida'))) {
        setatrTipoMedida(true);
        setatrMedida(true);
      } else {
        setatrTipoMedida(false);
        setatrMedida(false);
      }

      if (listaAtributos.includes(findAtributoByName('idINE'))) {
        setidIneImput(true);
      } else {
        setidIneImput(false);
      }

      if (listaAtributos.includes(findAtributoByName('duracionHr'))) {
        setatrduracionHr(true);
      } else {
        setatrduracionHr(false);
      }
      if (listaAtributos.includes(findAtributoByName('duracionMin'))) {
        setatrduracionMin(true);
      } else {
        setatrduracionMin(false);
      }
      if (listaAtributos.includes(findAtributoByName('duracionSeg'))) {
        setatrduracionSeg(true);
      } else {
        setatrduracionSeg(false);
      }
      if (listaAtributos.includes(findAtributoByName('campaniaAnterior'))) {
        setatrcampaniaAnterior(true);
      } else {
        setatrcampaniaAnterior(false);
      }
      if (atributos?.search('40') !== -1) {
        setatrAlto(true);
      } else {
        setatrAlto(false);
      }
      if (atributos?.search('41') !== -1) {
        setatrAncho(true);
      } else {
        setatrAncho(false);
      }
      if (listaAtributos.includes(findAtributoByName('cantidad'))) {
        setatrCantidad(true);
      } else {
        setatrCantidad(false);
      }
      if (listaAtributos.includes(findAtributoByName('lema'))) {
        setatrLema(true);
      } else {
        setatrLema(false);
      }
      if (listaAtributos.includes(findAtributoByName('placas'))) {
        setatrPlacas(true);
      } else {
        setatrPlacas(false);
      }
      if (listaAtributos.includes(findAtributoByName('infAdicional'))) {
        setatrinfoAdicional(true);
      } else {
        setatrinfoAdicional(false);
      }
    }
  };

  const actualizaTipoHallazgo = async () => {
    try {
      renderDtoHllazgos2();
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  const atributosHallazgos = useSelector(selectCatalogByName(ATRIBUTOS));

  const findAtributoByName = (nombreAtributo) => {
    const idAtributo = atributosHallazgos.find(
      (atributo) => atributo.atributo === nombreAtributo
    )?.idAtributo;
    return idAtributo.toString();
  };

  function handleClick(key) {
    setActiveKey(key);
  }

  const uploadsComponent = () => {
    const uploads = Array.from({ length: 5 }).map((_, index) => (
      <Form.Item
        required={index < 2}
        name={[`muestra_${index}`]}
        label={`Muestra ${index + 1}`}
        className={index < 2 && fileList.length + muestrasList.length < 2 && 'upload-muestras'}>
        {index + 1 <= fileList.length ? (
          <Upload fileList={[fileList[index]]} hideNextUpload onChange={handleCharge} />
        ) : (
          <Upload onChange={handleCharge} onRemove={handleRemove} className="muestra-requerida" />
        )}
      </Form.Item>
    ));

    return uploads;
  };

  return (
    <Modal
      name="modal-hallazgo"
      footer={null}
      width="95%"
      open={open}
      onCancel={handleCancel}
      afterClose={() => {
        setMuestrasList([]);
        setFileList([]);
        form.resetFields();
      }}
      centered>
      {contextHolder}
      <Form name="form-h" layout="vertical" form={form}>
        <h2 style={{ color: '#c12b7d', fontWeight: 'bold' }}>Editar hallazgo</h2>
        <p className="">
          Folio de monitoreo: <span className="">{folio}</span>
        </p>
        <div>
          <span className="modal-formulario-subtitulo-descripcion">
            Captura la información solicitada.
          </span>
          <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
        </div>
        <Row>
          <Col span={5}>
            <Form.Item
              label="Proceso Electoral"
              required
              name="idProcesoElectoral"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}
              style={{ width: '20em', margin: '1em 0' }}>
              <Select
                options={procesosElectorales}
                placeholder="Selecciona el Proceso Electoral"
                fieldNames={{
                  value: 'idProcesoElectoral',
                  label: 'descripcion'
                }}
                onChange={(e) => handleCambioProceso(e)}
              />
            </Form.Item>
          </Col>
          <Col span={5} push={1}>
            <Form.Item
              name="estatus"
              label="Estatus:"
              style={{ width: '20em', margin: '1em 0' }}
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                fieldNames={{ value: 'id', label: 'nombre' }}
                maxLength={100}
                optionFilterProp="children"
                placeholder="Filtra"
                options={optionsEstatus}
                onChange={(e) => hamdleCambioStatus(e)}
                disabled={!dataActa.tieneActas}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>{hallazgoCancelado === true ? CampoCancelado() : <div />}</Row>
        <Collapse
          defaultActiveKey={['']}
          activeKey={activeKey}
          className="collapse-espec"
          onChange={(e) => handleClick(e)}>
          <Panel header="Muestras" key="1" forceRender className="panel-muestras">
            <Spin spinning={loadingImages}>{uploadsComponent()}</Spin>
          </Panel>
          <Panel header="Datos generales" key="2" forceRender>
            <DatosGenerales form={form} />
          </Panel>
          <Panel header="Beneficiados" key="3" forceRender>
            <div className="formulario-beneficiados">
              <Form form={form} layout="vertical">
                <Form.Item
                  name="tipoBeneficio"
                  label="Tipo de beneficio"
                  rules={[
                    {
                      required: true,
                      message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                    }
                  ]}>
                  <Select
                    placeholder="Seleccionar tipo de beneficio"
                    options={tipoBeneficios.map((beneficio) => ({
                      label: beneficio.nombreTipoBeneficio,
                      value: beneficio.idTipoBeneficio
                    }))}
                    style={{ width: '20em' }}
                    onChange={handleChange}
                  />
                </Form.Item>
                {renderHeaders(tipoBeneficioSelecionado)}
                <Form.List name="beneficiados" initialValue={[]}>
                  {(fields, { add }) => (
                    <>
                      {fields.map((field, index) => {
                        const tipoBeneficio = form.getFieldValue('tipoBeneficio');
                        if (!tipoBeneficio) return null;
                        return renderInput(tipoBeneficioSelecionado, field, index);
                      })}
                      <Divider />
                      <Form.Item>
                        {(tipoBeneficioSelecionado === 3 ||
                          tipoBeneficioSelecionado === 4 ||
                          form.getFieldValue('beneficiados').length === 0) && (
                          <AddButton onClick={() => add()}>Agregar Nuevo</AddButton>
                        )}
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </Panel>
          <Panel header="Datos del hallazgo" key="4" forceRender>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.hallazgo !== curValues.hallazgo;
              }}>
              {() => {
                const listaAtributos =
                  tipoHallazgos
                    .find((tipo) => tipo.idHallazgo === form.getFieldsValue()?.hallazgo)
                    ?.atributos?.split(',') || [];

                const atributosInputs = [];
                atributosInputs.push(
                  <Row gutter={20}>
                    <TipoHallazgo
                      form={form}
                      catIdIne={catIdIne}
                      actualizaTipoHallazgo={actualizaTipoHallazgo}
                    />
                    {listaAtributos.includes(findAtributoByName('idTipoMedida')) && (
                      <Col span={4}>
                        <Form.Item
                          name="idTipoMedida"
                          label="Tipo medida:"
                          rules={[
                            { required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }
                          ]}>
                          <Select
                            fieldNames={{ value: 'idTipoMedida', label: 'tipoMedida' }}
                            optionFilterProp="children"
                            placeholder="Selecciona"
                            allowClear
                            options={dataActa.catMedida}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {listaAtributos.includes(findAtributoByName('medida')) && (
                      <Col span={4}>
                        <Form.Item
                          name="medida"
                          label="Medida:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    )}
                    {(listaAtributos.includes(findAtributoByName('duracionHr')) ||
                      listaAtributos.includes(findAtributoByName('duracionMin')) ||
                      listaAtributos.includes(findAtributoByName('duracionSeg'))) && (
                      <Form.Item
                        // label="Duración:"
                        rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
                        <Col xs={24} style={{ minWidth: '200px' }}>
                          <div
                            className="div-reloj-campo-completo"
                            style={{ marginTop: '25px', marginLeft: '25px' }}>
                            <div>
                              <IconReloj className="reloj-icon-completo" />
                            </div>
                            {listaAtributos.includes(findAtributoByName('duracionHr')) && (
                              <>
                                <Col span={4}>
                                  <Form.Item
                                    name="duracionHr"
                                    label=" "
                                    rules={[
                                      { required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }
                                    ]}>
                                    <SimpleNumericInput />
                                  </Form.Item>
                                </Col>
                                <Col span={2}>
                                  <div className="butonrender">&nbsp;</div>
                                  <span>Hrs</span>
                                </Col>
                              </>
                            )}
                            {listaAtributos.includes(findAtributoByName('duracionMin')) && (
                              <>
                                <Col span={4}>
                                  <Form.Item
                                    name="duracionMin"
                                    label="Duración:"
                                    rules={[
                                      { required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }
                                    ]}>
                                    <SimpleNumericInput />
                                  </Form.Item>
                                </Col>
                                <Col span={2}>
                                  <div className="butonrender" style={{ marginTop: '-20px' }}>
                                    &nbsp;
                                  </div>
                                  <span>Min.</span>
                                </Col>
                              </>
                            )}
                            {listaAtributos.includes(findAtributoByName('duracionSeg')) && (
                              <>
                                <Col span={4}>
                                  <Form.Item name="duracionSg" label=" ">
                                    <SimpleNumericInput />
                                  </Form.Item>
                                </Col>
                                <Col span={2}>
                                  <div className="butonrender" style={{ marginTop: '-20px' }}>
                                    &nbsp;
                                  </div>
                                  <span>Seg.</span>
                                </Col>
                              </>
                            )}
                          </div>
                        </Col>
                      </Form.Item>
                    )}

                    {listaAtributos.includes(findAtributoByName('campaniaAnterior')) && (
                      <Col xs={8} style={{ minWidth: '200px' }}>
                        <Form.Item name="campanaAnterior" label=" ">
                          <Checkbox
                            defaultChecked={atrCampaniaAnteriorCheck}
                            onChange={(e) => propCampania(e)}>
                            ¿Es propaganda de campaña anterior?
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    )}
                    {listaAtributos.includes(findAtributoByName('cantidad')) && (
                      <Col span={2}>
                        <Form.Item
                          name="cantidad"
                          label="Cantidad:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input maxLength={10} />
                        </Form.Item>
                      </Col>
                    )}
                    {listaAtributos.includes(findAtributoByName('lema')) && (
                      <Col span={5}>
                        <Form.Item
                          name="lema"
                          label="Lema:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    )}
                    {listaAtributos.includes(findAtributoByName('placas')) && (
                      <Col span={5}>
                        <Form.Item
                          name="placas"
                          label="Placas:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input />
                        </Form.Item>
                      </Col>
                    )}
                    {listaAtributos.includes(findAtributoByName('infAdicional')) && (
                      <Col span={12}>
                        <Form.Item
                          name="infoAdicional"
                          label="Información adicional (modo, tiempo, lugar):"
                          rules={[{ required: false, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <TextArea rows={2} showCount maxLength={1200} placeholder="Escribe.." />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                );
                return atributosInputs;
              }}
            </Form.Item>
          </Panel>
          <Panel header="Ubicación del hallazgo" key="5" forceRender>
            <Ubicacion
              form={form}
              idTipoHallazgo={dataActa.idTipoHallazgo}
              latitud={dataActa.ubicacion?.latitud}
              longitud={dataActa.ubicacion?.longitud}
            />
          </Panel>
        </Collapse>
        <Spin spinning={loading}>
          <Row style={{ width: '100%' }} className="margenbooton">
            <Col span={11} className="col-header-table-col1" />
            <Col span={12} className="margenbooton">
              <Form.Item>
                <Button type="primary" htmlType="submit" onClick={handleFound} text="Guardar">
                  Guardar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Form>
    </Modal>
  );
}

export default ModalActa;
